import { put, call, all, takeEvery, select } from 'redux-saga/effects';
import _ from 'lodash';
import chunk from 'lodash/chunk';
import moment from 'moment-timezone';
import { REPORT, ENDPOINT } from '../constants';
import TepcoConfig from "../config/TepcoConfig";
import TagConfig from "../config/TagConfig";
import LocalStorageHelper from "../utils/helper/localstorage_helper";

import {
  setPageTopLoader,
  setReportData,
  setFilteredTotal,
  setReportFilteredTotal,
  setDownloadReportData,
  setReportTagFilterData,
  setImageDataByReportId,
  setImageDataByOtherUsers,
  setNoImageDataByReportId,
  setReportDataNtt,
  setReportTagFilterDataNtt,
  setReportDataMission,
  setReportTagFilterDataMission,
  setReportDataHokuden,
  setReportTagFilterDataHokuden,
  setHokudenReportOptionCity,
  setHokudenReportOptionBranch,
  setViewerImageDataExtra,
} from '../actions';

import {
  getJwtToken,
  getDataFromKpiDash,
} from '../api';

const S3_BUCKET_BASE_URL = process.env.REACT_APP_S3_BUCKET_BASE_URL;

const formatToJST = (isoString) => {
  const [datePart, timePart] = isoString.split("T"); // ["2025-02-19", "16:17:36.833Z"]
  const timeOnly = timePart.split(".")[0]; // "16:17:36"
  return `${datePart.replace(/-/g, "/")} ${timeOnly}`; // "-" を "/" に変換
};

const sortReportTags = (reportTagListDataParsed) => {
  return reportTagListDataParsed.sort((a, b) => {
    return (
      TepcoConfig.reportTagSort.indexOf(a.label) -
      TepcoConfig.reportTagSort.indexOf(b.label)
    );
  });
};

const env = process.env.REACT_APP_ENV;
const tagResultTable = env === 'prod' ? "PicTreeViewerReportTagProd" : "PicTreeViewerReportTagDev";

const tagTipMap = new Map();
TagConfig.reportResultTagTip.forEach(tag => {
  tagTipMap.set(tag.value, tag.tip);
});

export const periodType = state => state.app.periodType;
export const selectedSeason = state => state.app.selectedSeason;
export const selectedMission = state => state.app.selectedMission;
export const startDate = state => state.app.dateRange[0];
export const endDate = state => state.app.dateRange[1];
export const filter = state => state.report.filter;
export const filterType = state => state.app.filterType;
export const filterNtt = state => state.report.filterNtt;
export const filterHokuden = state => state.report.filterHokuden;
export const filterMission = state => state.report.filterMission;

export function* handleReportDownloadData(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const tableName = localStorage.getItem("access_key") === "qf70ypdjdzm89ypqvc4r7nf9"
    ? "power_asset_detail_of_ntt_me" : localStorage.getItem("access_key") === "lqdp4c7fuwgfz89og7q4x9f3"
    ? "power_asset_detail_of_hepco" : localStorage.getItem("access_key") === "z7n3q9m1x4p2v0ydk8twr5fb"
      ? env === "dev" ? "power_asset_detail_of_ntt_me" : "power_asset_detail_of_ntt_ft"
      : "power_asset_detail_of_tepco";
    yield put(setPageTopLoader(true));
    yield put(setDownloadReportData([]));
    const type = yield select(periodType);
    let dateFrom = yield select(startDate);
    let dateTo = yield select(endDate);
    dateFrom = moment(dateFrom).tz("Asia/Tokyo").format('YYYY-MM-DD');
    dateTo = moment(dateTo).tz("Asia/Tokyo").format('YYYY-MM-DD');
    const assetFilter = yield select(filter);
    const seasonIdSelected = yield select(selectedSeason);
    const orderValue = assetFilter.order == "desc" ? "DESC" : "ASC";
    const equipmentNumber = assetFilter.assetId === null ? false : assetFilter.assetId;
    const signNumber = assetFilter.signNumber === null ? false : assetFilter.signNumber;
    let assetType = assetFilter.assetType === "all" ? false : assetFilter.assetType;
    const manageGroup = assetFilter.manageGroup.key === "all" ? false : assetFilter.manageGroup.value;
    const reportTime = assetFilter.reportTime;
    const tagResult = assetFilter.tagResult;

    // Date range query
    const dateRangeQuery = type === "season"
    ? `AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') >= '${dateFrom} 00:00:00'
        AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') <= '${dateTo} 23:59:59'`
    : "";

    // 報告確認結果 if tagResult is not empty, then fetch data by tagResult from KPI RDS first
    let tagResultWhereQuery = ``, tagResultData = [];
    if (tagResult.length > 0) {
      const includesUnconfirmed = tagResult.includes("-（未確認）");
      if (includesUnconfirmed) {
        const sqlQueryExcludeConfirmed = {
          query: `
            SELECT DISTINCT report_id
            FROM ${tagResultTable}
            WHERE CONVERT_TZ(occurred_datetime, '+00:00', '+09:00') >= '${dateFrom} 00:00:00'
            AND CONVERT_TZ(occurred_datetime, '+00:00', '+09:00') <= '${dateTo} 23:59:59';
          `,
          type: "select"
        };

        const [confirmedResultTagData] = yield all([
          call(getDataFromKpiDash, sqlQueryExcludeConfirmed, ENDPOINT.GET_DATA_KPIDASH_API),
        ]);

        const confirmedReportIds = confirmedResultTagData.map(row => `'${row[0].stringValue}'`);

        if (confirmedReportIds.length > 0) {
          tagResultWhereQuery = `AND rr.id NOT IN (${confirmedReportIds.join(", ")})`;
        } else {
          tagResultWhereQuery = ``;
        }
      } else {
        const tagLikeConditions = tagResult.map(tag => `result_tag_flat LIKE '%${tag}%'`).join(" OR ");
        const sqlQueryGetResultTag = {
          query: `
            SELECT report_id, result_tag_array, result_tag_flat
            FROM ${tagResultTable}
            WHERE (${tagLikeConditions})
            AND CONVERT_TZ(occurred_datetime, '+00:00', '+09:00') >= '${dateFrom} 00:00:00'
            AND CONVERT_TZ(occurred_datetime, '+00:00', '+09:00') <= '${dateTo} 23:59:59';
          `,
          type: "select"
        };
        const [getResultTagDataTemp] =
          yield all([
            call(
              getDataFromKpiDash,
              sqlQueryGetResultTag,
              ENDPOINT.GET_DATA_KPIDASH_API
            ),
          ]);
        if (getResultTagDataTemp.length > 0) {
          tagResultWhereQuery = `AND rr.id IN (${getResultTagDataTemp.map(item => `'${item[0].stringValue}'`).join(", ")})`;
        }
      }
    } else {
      // No result tag filter
      const sqlQueryGetAllResultTag = {
        query: `
          SELECT report_id, result_tag_array, result_tag_flat
          FROM ${tagResultTable}
          WHERE occurred_datetime >= '${dateFrom} 00:00:00'
          AND occurred_datetime <= '${dateTo} 23:59:59';
        `,
        type: "select"
      };
      const [getResultTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryGetAllResultTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      tagResultData = getResultTagDataTemp;
    }

    const reportIdToResultInfo = new Map();
    tagResultData.forEach(row => {
      const reportId = row[0].stringValue;
      const tagArrayString = row[1].stringValue; // e.g., '["ツルツタLv.0-2","ツルツタLv.1−1"]'
      const tagFlat = row[2].stringValue;         // e.g., 'ツルツタLv.0-2,ツルツタLv.1−1'

      let tipString = "";
      try {
        const parsedTags = JSON.parse(tagArrayString);
        const tips = parsedTags
          .map(tag => tagTipMap.get(tag))
          .filter(Boolean);
        tipString = tips.join(" / ");
      } catch (e) {
        console.warn("Invalid tag JSON:", tagArrayString);
      }

      reportIdToResultInfo.set(reportId, {
        tag: tagFlat,
        tip: tipString
      });
    });

    // 地上設備 x 2種類
    let assetType2 = "";
    if (assetType && assetType.includes("GROUND_EQUIPMENT")) {
      assetType2 = assetType.split("-")[1];
      assetType = assetType.split("-")[0];
    }

    const seasonIdQuery = type === "season" && seasonIdSelected !== "all"
      ? `AND ppa.game_space_id = '${seasonIdSelected}'` : "";

    const assetIdQuery = equipmentNumber
      ? `AND padtep.equipment_number = '${equipmentNumber}'` : "";

    const signNumberQuery = signNumber
      ? `AND padtep.sign_number = '${signNumber}'` : "";

    let assetTypeQuery = assetType && assetType !== "POWER_POLE_HAS_PROTECTIVE_TUBE_ALL"
      ? `AND pa.type = '${assetType}'` : "";

    const assetTypeQuery2 = assetType2 !== "" ? `AND padtep.equipment_code = '${assetType2}'` : "";

    // ツルツタレビューOK画像
    let reviewRequestJoinQuery = `JOIN review_request rreq ON rreq.power_asset_id = rr.power_asset_id`;
    // if (seasonIdSelected === "cm9jq577000034hpg5cngfzod" || seasonIdSelected === "cm9jq576y00014hpg0its7l4w") {
      if (reportTime === "all") {
        reviewRequestJoinQuery = `
        JOIN review_request rere ON rere.power_asset_id = rr.power_asset_id AND rere.status = 'APPROVED' and ps.player_id = rere.player_id
        JOIN review_request_event rre ON rere.id = rre.review_request_id AND rre.type = 'APPLIED' AND rre.occurred_datetime = re.occurred_datetime
        JOIN review_request_photo_bind rrpb ON rrpb.review_request_id = rere.id
        `
      } else {
        reviewRequestJoinQuery = `
        JOIN review_request rere ON rere.power_asset_id = rr.power_asset_id AND rere.status = 'APPROVED' and ps.player_id = rere.player_id
        JOIN review_request_event rre ON rere.id = rre.review_request_id AND rre.type = 'APPLIED' AND rre.occurred_datetime = re.occurred_datetime
        JOIN review_request_event rre2 ON rere.id = rre2.review_request_id AND rre2.type = 'APPROVED'
        JOIN review_request_event_of_approved rreoa ON rre2.id = rreoa.id AND rreoa.review_approved_count = '${reportTime}'
        JOIN review_request_photo_bind rrpb ON rrpb.review_request_id = rere.id
        `
      }
    // }

    // 防護管付き電柱
    let bogokanJoinQuery = ``;
    let bogokanWhereQuery = ``;
    if (assetType && assetType.includes("POWER_POLE_HAS_PROTECTIVE_TUBE_ALL")) {
      bogokanJoinQuery = `JOIN power_pole pp ON padtep.power_asset_id = pp.id`
      bogokanWhereQuery = `AND pp.power_pole_type = 'HAS_PROTECTIVE_TUBE'`
    } else if (assetType && assetType.includes("POWER_POLE_HAS_PROTECTIVE_TUBE_WITH_PIC")) {
      bogokanJoinQuery = `
        JOIN power_asset_angle_of_view_name_v2 paaovn ON paaovn.power_asset_photography_target_id = ppa.power_asset_photography_target_id
        AND paaovn.language_code = 'JA'
        JOIN power_pole pp ON rr.power_asset_id = pp.id
      `;
      bogokanWhereQuery = `AND pp.power_pole_type = 'HAS_PROTECTIVE_TUBE' AND paaovn.angle_of_view_name like '% - 防護管%'`
      assetTypeQuery = "";
    }

    // 高圧設備あり
    let plantInsulateSwitchJoinQuery = ``;
    let plantInsulateSwitchWhereQuery = ``;
    if (assetType && assetType.includes("POWER_POLE_HAS_INSULATE_SWITCH")) {
      plantInsulateSwitchJoinQuery = `LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = pa.id`
      plantInsulateSwitchWhereQuery = `
      AND pa.type = 'POWER_POLE'
      AND paiwais.power_asset_id is not NULL`;
      assetTypeQuery = "";
    }

    // 低圧
    if (assetType && assetType.includes("POWER_POLE_NO_INSULATE_SWITCH")) {
      plantInsulateSwitchJoinQuery = `LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = pa.id`
      plantInsulateSwitchWhereQuery = `
      AND pa.type = 'POWER_POLE'
      AND paiwais.power_asset_id is NULL`;
      assetTypeQuery = "";
    };

    // ツルツタ台帳記載・高圧設備なし
    if (assetType && assetType.includes("POWER_POLE_HAS_PLNAT")) {
      plantInsulateSwitchJoinQuery = `LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = pa.id`
      plantInsulateSwitchWhereQuery = `
        AND pa.type = 'POWER_POLE'
        AND pa.sub_type = 'WITH_PLANTS'
        AND paiwais.power_asset_id is NULL
      `;
      assetTypeQuery = "";
    }

    // ツルツタ台帳記載・高圧設備あり
    if (assetType && assetType.includes("POWER_POLE_HAS_PLNAT_AND_INSULATE_SWITCH")) {
      plantInsulateSwitchJoinQuery = `LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = pa.id`
      plantInsulateSwitchWhereQuery = `
        AND pa.type = 'POWER_POLE'
        AND pa.sub_type = 'WITH_PLANTS'
        AND paiwais.power_asset_id is not NULL
      `;
      assetTypeQuery = "";
    }

    // 配電保守グループ
    let managementGroupQuery = ``;
    if (manageGroup) {
      const manageGroupCommaSeparated = manageGroup.join("','");
      managementGroupQuery = `AND padtep.place_code IN ('${manageGroupCommaSeparated}')`;
    }

    const tagQuery = assetFilter.tag.length > 0
      ? `AND rcd.tag_label IN ('${assetFilter.tag.join("','")}')` : "";

    let sqlQuery = {};
    sqlQuery.query = `
      SELECT
          rr.id,
          rr.game_space_id,
          rr.power_asset_id,
          ps.name,
          padtep.*,
          ps.player_id,
          padtep.place_code,
          padtep.sign_number,
          padtep.sign_name,
          padtep.equipment_code,
          padtep.equipment_number,
          CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
          rcd.tag_id AS tag_ids,
          rcd.tag_label AS tag_label,
          rcd.additional_comment AS comment,
          rtdn.name AS tag_display_names,
          rp.object_key AS photo_urls
      FROM report rr
      JOIN report_content_detail rcd ON rr.id = rcd.report_id
      JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
      LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      JOIN power_asset pa ON pa.id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      ${reviewRequestJoinQuery}
      ${bogokanJoinQuery}
      ${plantInsulateSwitchJoinQuery}
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      ${dateRangeQuery}
      ${seasonIdQuery}
      ${assetIdQuery}
      ${signNumberQuery}
      ${managementGroupQuery}
      ${tagQuery}
      ${assetTypeQuery}
      ${assetTypeQuery2}
      ${bogokanWhereQuery}
      ${plantInsulateSwitchWhereQuery}
      ${tagResultWhereQuery}
      GROUP BY occurred_datetime_jst, tag_label
      ORDER BY rr.report_datetime ${orderValue};
    `;

    const [reportDownloadDataTemp] = yield all([
      call(getDataFromKpiDash, sqlQuery, ENDPOINT.GET_DATA_API_REPLICA),
    ]);
    const downloadCsvData = JSON.parse(reportDownloadDataTemp.body);

    const reportDownloadArray = [
        ["タイムスタンプ", "スキーマ番号", "標識番号", "標識名", "設備コード", "設備番号",
          "プレイヤー名", "プレイヤーID", "報告タグ", "報告内容", "報告確認結果タグ", "報告確認結果内容"],
        ...downloadCsvData.map((item, index) => {
          const reportId = item.id;
          const resultInfo = reportIdToResultInfo.get(reportId) || { tag: "", tip: "" };

          return [
            formatToJST(item.occurred_datetime_jst),
            item.place_code,
            item.sign_number,
            item.sign_name,
            item.equipment_code,
            item.equipment_number,
            item.name,
            item.player_id,
            item.tag_label,
            (item.tag_label === "その他" ? item.comment : item.tag_display_names),
            resultInfo.tag,
            resultInfo.tip
        ]
      }), // 行データ
    ];

    yield put(setDownloadReportData(reportDownloadArray));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleReportDownloadDataNtt(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const tableName = localStorage.getItem("access_key") === "qf70ypdjdzm89ypqvc4r7nf9"
    ? "power_asset_detail_of_ntt_me" : localStorage.getItem("access_key") === "lqdp4c7fuwgfz89og7q4x9f3"
    ? "power_asset_detail_of_hepco" : localStorage.getItem("access_key") === "z7n3q9m1x4p2v0ydk8twr5fb"
      ? env === "dev" ? "power_asset_detail_of_ntt_me" : "power_asset_detail_of_ntt_ft"
      : "power_asset_detail_of_tepco";
    yield put(setPageTopLoader(true));
    yield put(setDownloadReportData([]));
    const type = yield select(periodType);
    let dateFrom = yield select(startDate);
    let dateTo = yield select(endDate);
    dateFrom = moment(dateFrom).tz("Asia/Tokyo").format('YYYY-MM-DD');
    dateTo = moment(dateTo).tz("Asia/Tokyo").format('YYYY-MM-DD');
    const assetFilter = yield select(filterNtt);
    const seasonIdSelected = yield select(selectedSeason);
    const orderValue = assetFilter.order == "desc" ? "DESC" : "ASC";
    const tagResult = assetFilter.tagResult;

    // Date range query
    const dateRangeQuery = type === "season"
    ? `AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') >= '${dateFrom} 00:00:00'
        AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') <= '${dateTo} 23:59:59'`
    : "";

    //　県域
    const prefecturalArea = assetFilter.prefecturalArea === "all" ? false : assetFilter.prefecturalArea;
    const prefecturalAreaQuery = prefecturalArea && prefecturalArea !== "all"
      ? `AND padtep.prefectural_area LIKE '%${prefecturalArea}%'` : "";

    // 収容局名
    const exchangeOfficeName = assetFilter.exchangeOfficeName === "all" ? false : assetFilter.exchangeOfficeName;
    const exchangeOfficeNameQuery = exchangeOfficeName && exchangeOfficeName !== "all"
      ? `AND padtep.exchange_office_name LIKE '%${exchangeOfficeName}%'` : "";

    // 設備番号
    const assetInfo =
      assetFilter.assetInfo === "all"
        ? false
        : assetFilter.assetInfo;
    const assetInfoQuery =
      assetInfo && assetInfo !== "all"
        ? `AND padtep.asset_info LIKE '%${assetInfo}%'`
        : "";

    // 撮影対象
    const photographyTarget =
      assetFilter.photographyTarget === "all"
        ? false
        : assetFilter.photographyTarget;
    const photographyTargetQuery =
      photographyTarget && photographyTarget !== "all"
        ? `AND padtep.photography_target LIKE '%${photographyTarget}%'`
        : "";

    // 撮影種別
    let photoType = assetFilter.photoType === "all" ? false : assetFilter.photoType;
    // need to change here
    let photoTypeQuery = ''; // taken from here
      if (photoType) {
        switch(photoType) {
          case "CONCRETE":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE', 'TELEGRAPH_CONCRETE_LUCKY_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE')`;
            break;
          case "CONCRETE_LUCKY":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_LUCKY_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE')`;
            break;
          case "CONCRETE_REGULAR":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE')`;
            break;
          case "STEEL":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_STEEL_PIPE_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE', 'TELEGRAPH_STEEL_PIPE_LUCKY_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE')`;
            break;
          case "STEEL_LUCKY":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_STEEL_PIPE_LUCKY_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE')`;
            break;
          case "STEEL_REGULAR":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_STEEL_PIPE_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE')`;
            break;
          case "TARGET_LUCKY":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_LUCKY_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE', 'TELEGRAPH_STEEL_PIPE_LUCKY_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE')`;
            break;
          case "TARGET_REGULAR":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE', 'TELEGRAPH_STEEL_PIPE_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE')`;
            break;
          default:
            photoTypeQuery = '';
        }
      }

    //　二段階判定対象
    const targetSubType = `'TELEGRAPH_CONCRETE_LUCKY_POLE',
                            'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE',
                            'TELEGRAPH_STEEL_PIPE_LUCKY_POLE',
                            'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE'`
    photoType = assetFilter.twoStepVerification === "all" ? false : assetFilter.twoStepVerification;
    photoTypeQuery = photoType && photoType == "target"
    ? `AND pa.sub_type IN (${targetSubType})`
    : photoType && photoType == "non-target"
      ? `AND pa.sub_type NOT IN (${targetSubType})`
      : photoTypeQuery;

    const seasonIdQuery = type === "season" && seasonIdSelected !== "all"
      ? `AND ppa.game_space_id = '${seasonIdSelected}'` : "";

    const tagQuery = assetFilter.tag.length > 0
      ? `AND rcd.tag_label IN ('${assetFilter.tag.join("','")}')` : "";

    const padTypeQueryJoin = seasonIdSelected === "cmb68qvei00011vo0e591229z"
      ? `JOIN power_asset_detail pad ON padtep.power_asset_id = pad.power_asset_id`
      : ``;
    const padTypeQuery = seasonIdSelected === "cmb68qvei00011vo0e591229z"
      ? `AND pad.type = 'NTT'`
      : ``;

    let sqlQuery = {};
    sqlQuery.query = `
      SELECT
          rr.id,
          rr.game_space_id,
          rr.power_asset_id,
          ps.name,
          padtep.*,
          ps.player_id,
          CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
          rcd.tag_id AS tag_ids,
          rcd.tag_label AS tag_label,
          rcd.additional_comment AS comment,
          rtdn.name AS tag_display_names
      FROM report rr
      JOIN report_content_detail rcd ON rr.id = rcd.report_id
      JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
      LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      ${padTypeQueryJoin}
      JOIN power_asset pa ON pa.id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      ${padTypeQuery}
      ${dateRangeQuery}
      ${seasonIdQuery}
      ${photoTypeQuery}
      ${prefecturalAreaQuery}
      ${exchangeOfficeNameQuery}
      ${assetInfoQuery}
      ${photographyTargetQuery}
      ${tagQuery}
      GROUP BY occurred_datetime_jst
      ORDER BY rr.report_datetime ${orderValue};
    `;

    const [reportDownloadDataTemp] = yield all([
      call(getDataFromKpiDash, sqlQuery, ENDPOINT.GET_DATA_API_REPLICA),
    ]);
    const downloadCsvData = JSON.parse(reportDownloadDataTemp.body);
    console.log("LOG sxi downloadCsvData:", downloadCsvData);

    const reportDownloadArray = [
        ["県域", "収容局名", "電柱情報", "撮影対象", "報告者", "報告タグ", "報告内容", "報告日時"],
        ...downloadCsvData.map((item, index) => {
          return [
            item.prefectural_area,
            item.exchange_office_name,
            item.asset_info,
            item.photography_target,
            item.name,
            item.tag_label,
            (item.tag_label === "その他" ? item.comment : item.tag_display_names),
            formatToJST(item.occurred_datetime_jst),
        ]
      }), // 行データ
    ];

    yield put(setDownloadReportData(reportDownloadArray));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleReportDownloadDataHokuden(action) {
  try {
    yield put(setPageTopLoader(true));
    yield put(setDownloadReportData([]));
    const type = yield select(periodType);
    let dateFrom = yield select(startDate);
    let dateTo = yield select(endDate);
    dateFrom = moment(dateFrom).tz("Asia/Tokyo").format('YYYY-MM-DD');
    dateTo = moment(dateTo).tz("Asia/Tokyo").format('YYYY-MM-DD');
    const assetFilter = yield select(filterHokuden);
    const seasonIdSelected = yield select(selectedSeason);
    const orderValue = assetFilter.order == "desc" ? "DESC" : "ASC";

    // Date range query
    const dateRangeQuery = type === "season"
      ? `AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') >= '${dateFrom} 00:00:00'
         AND CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') <= '${dateTo} 23:59:59'`
      : "";

    //　電柱番号
    const powerAssetNumber = assetFilter.powerAssetNumber === "all" ? false : assetFilter.powerAssetNumber;
    const powerAssetNumberQuery = powerAssetNumber && powerAssetNumber !== "all"
      ? `AND padtep.power_pole_number LIKE '%${powerAssetNumber}%'` : "";

    //　撮影者
    const username =
      assetFilter.username === "all"
        ? false
        : assetFilter.username;
    const usernameQuery =
      username && username !== "all"
        ? `AND ps.name LIKE '%${username}%'`
        : "";

    // 市町村名
    const cityName = assetFilter.municipality === "all" ? false : assetFilter.municipality;
    const cityNameQuery = cityName && cityName !== "all"
      ? `AND padtep.representative_municipality_code = '${cityName}'` : "";

    // 支店コード
    const branchName = assetFilter.branchName === "all" ? false : assetFilter.branchName;
    const branchNameQuery = branchName && branchName !== "all"
      ? `AND padtep.branch_code = '${branchName}'` : "";

    const seasonIdQuery = type === "season" && seasonIdSelected !== "all"
      ? `AND ppa.game_space_id = '${seasonIdSelected}'` : "";

    // Report tag
    const tagQuery = assetFilter.tag.length > 0
    ? `AND rcd.tag_label IN ('${assetFilter.tag.join("','")}')` : "";

    let sqlQuery = {};
    sqlQuery.query = `
      SELECT
          rr.id,
          rr.game_space_id,
          rr.power_asset_id,
          ps.name,
          padtep.*,
          ps.player_id,
          rr.report_datetime AS occurred_datetime,
          pa.latitude,
          pa.longitude,
          CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
          GROUP_CONCAT(DISTINCT rcd.tag_id) AS tag_ids,
          GROUP_CONCAT(DISTINCT rcd.tag_label) AS tag_label,
          rcd.additional_comment AS comment,
          GROUP_CONCAT(DISTINCT rtdn.name) AS tag_display_names,
          GROUP_CONCAT(DISTINCT rp.object_key) AS photo_urls
      FROM report rr
      JOIN report_content_detail rcd ON rr.id = rcd.report_id
      JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
      LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN power_asset_detail_of_hepco padtep ON rr.power_asset_id = padtep.power_asset_id
      JOIN power_asset_detail pad ON padtep.power_asset_id = pad.power_asset_id
      JOIN power_asset pa ON pa.id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      AND pad.type = 'HEPCO'
      ${dateRangeQuery}
      ${seasonIdQuery}
      ${powerAssetNumberQuery}
      ${cityNameQuery}
      ${branchNameQuery}
      ${usernameQuery}
      ${tagQuery}
      GROUP BY rr.id
      ORDER BY rr.report_datetime ${orderValue}
    `;

    const [reportDownloadDataTemp] = yield all([
      call(getDataFromKpiDash, sqlQuery, ENDPOINT.GET_DATA_API_REPLICA),
    ]);
    const downloadCsvData = JSON.parse(reportDownloadDataTemp.body);
    console.log("LOG sxi downloadCsvData:", downloadCsvData);

    const reportDownloadArray = [
        ["電柱番号", "市町村名", "支店コード", "報告タグ", "報告内容", "報告者",  "報告日時"],
        ...downloadCsvData.map((item) => {
          return [
            item.power_pole_number,
            item.representative_municipality_name,
            item.branch_code,
            item.tag_label,
            (item.tag_label === "その他" ? item.comment : item.tag_display_names),
            item.name,
            formatToJST(item.occurred_datetime_jst),
        ]
      }), // 行データ
    ];

    yield put(setDownloadReportData(reportDownloadArray));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleReportDataByReportId(action) {
  try {
    const companyName = LocalStorageHelper.getCompany();
    const env = process.env.REACT_APP_ENV;
    let tableName = "power_asset_detail_of_tepco";
    if (companyName === "ntt") {
      tableName = "power_asset_detail_of_ntt_me";
    } else if (companyName === "ntt-ft") {
      tableName = env === "dev" ? "power_asset_detail_of_ntt_me" : "power_asset_detail_of_ntt_ft";
    } else if (companyName === "hokuden") {
      tableName = "power_asset_detail_of_hepco"
    } else if (companyName === "mitsubishi") {
      tableName = "power_asset_detail_of_mission_venue"
    }
    yield put(setPageTopLoader(true));
    yield put(setFilteredTotal("--"));

    let dateFrom = yield select(startDate);
    let dateTo = yield select(endDate);
    dateFrom = moment(dateFrom).tz("Asia/Tokyo").format('YYYY-MM-DD');
    dateTo = moment(dateTo).tz("Asia/Tokyo").format('YYYY-MM-DD');
    const reportId = action.payload;

    let sqlQueryReportData = {};
    sqlQueryReportData.query = `
      SELECT
          rr.id,
          rr.power_asset_id,
          rr.game_space_id,
          ps.name,
          padtep.*,
          ps.player_id,
          padtep.place_code,
          padtep.sign_number,
          padtep.sign_name,
          padtep.equipment_code,
          padtep.equipment_number,
          pa.latitude,
          pa.longitude,
          CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
          GROUP_CONCAT(DISTINCT rcd.tag_id) AS tag_ids,
          GROUP_CONCAT(DISTINCT rcd.tag_label) AS tag_label,
          rcd.additional_comment AS comment,
          GROUP_CONCAT(DISTINCT rtdn.name) AS tag_display_names,
          GROUP_CONCAT(DISTINCT rp.object_key) AS photo_urls,
          paiwais.power_asset_id AS insulated_switch
      FROM
          report rr
      JOIN
          report_content_detail rcd ON rr.id = rcd.report_id
      JOIN
          report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      LEFT OUTER JOIN
          report_photograph rp ON rp.report_id = rr.id
      join player_state ps ON rr.player_id = ps.player_id
      join power_asset_detail_of_tepco padtep ON rr.power_asset_id = padtep.power_asset_id
      JOIN power_asset pa ON pa.id = padtep.power_asset_id
      LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = padtep.power_asset_id
      where rtdn.language_code = 'JA' AND rr.status = 'REGISTERED' AND rr.id = '${reportId}'
      GROUP by rr.id
    `;

    if (companyName !== "tepco") {
      sqlQueryReportData.query = `
        SELECT
            rr.id,
            rr.power_asset_id,
            rr.game_space_id,
            ps.name,
            padtep.*,
            ps.player_id,
            pa.latitude,
            pa.longitude,
            CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
            GROUP_CONCAT(DISTINCT rcd.tag_id) AS tag_ids,
            GROUP_CONCAT(DISTINCT rcd.tag_label) AS tag_label,
            rcd.additional_comment AS comment,
            GROUP_CONCAT(DISTINCT rtdn.name) AS tag_display_names,
            GROUP_CONCAT(DISTINCT rp.object_key) AS photo_urls
        FROM
            report rr
        JOIN
            report_content_detail rcd ON rr.id = rcd.report_id
        JOIN
            report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
        LEFT OUTER JOIN
            report_photograph rp ON rp.report_id = rr.id
        join player_state ps ON rr.player_id = ps.player_id
        join ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
        JOIN power_asset pa ON pa.id = padtep.power_asset_id
        where rtdn.language_code = 'JA' AND rr.status = 'REGISTERED' AND rr.id = '${reportId}'
        GROUP by rr.id
      `
    }

    const [reportDataListTemp] = yield all([
      call(getDataFromKpiDash, sqlQueryReportData, ENDPOINT.GET_DATA_API_REPLICA),
    ]);

    // report data
    const reportData = JSON.parse(reportDataListTemp.body);
    let photoPathArray = [], photoFileNameArray = [], allPhotoUrl = [], tagLabelUnique = [], tagLabelDisplay = [];
    _.each(reportData, function(reportData) {
      const photoUrl = reportData.photo_urls !== null ? reportData.photo_urls.split(",") : [false];
      const fileName = reportData.photo_urls !== null ? photoUrl[0].split("Report/")[1] : false;
      let tagUniqueArray = reportData.tag_label.split(",");
      let tagDisplayArray = reportData.tag_display_names.split(",");
      photoPathArray.push(photoUrl[0]); // have multiple pic urls but use 1st one.
      photoFileNameArray.push(fileName);
      allPhotoUrl.push(photoUrl);
      tagLabelUnique.push([...new Set(tagUniqueArray)]);
      tagLabelDisplay.push([...new Set(tagDisplayArray)]);
    });

    // Setting no report image flag
    if (photoFileNameArray[0] !== undefined && !photoFileNameArray[0]) {
      yield put(setNoImageDataByReportId(true));
    }
    let reportFinalData = reportData.map((photoData, index) => ({
      reportId: photoData.id,
      gameSpaceId: photoData.game_space_id,
      powerAssetId: photoData.power_asset_id,
      signNumber: photoData.sign_number,
      signName: photoData.sign_name !== null && photoData.sign_name !== undefined ? photoData.sign_name : "--",
      name: photoData.equipment_number,
      placeCode: photoData.place_code !== null ? photoData.place_code : "--",
      latitude: photoData.latitude,
      longitude: photoData.longitude,
      tag: tagLabelUnique[0],//sortedTags, //["対象無し", "位置ズレ", "撮影困難"], sort to TEPCO order
      tagDisplay: tagLabelDisplay[0], // sortedTagsDisplay, //tagLabelDisplay[0], @todo, sort to TEPCO order
      comment: photoData.comment === null ? false : photoData.comment,
      user: photoData.name,
      playerId: photoData.player_id,
      fileUrl: photoPathArray[index] ? `${S3_BUCKET_BASE_URL}/${photoPathArray[index]}` : false,
      fileName: photoPathArray[index] ? photoFileNameArray[index].split(".jpg")[0] : false,
      occurred_datetime_jst: photoData.occurred_datetime_jst,
      allPhotoUrl: allPhotoUrl[index],
      withInsulatedSwitch: photoData.insulated_switch !== null ? true : false,
    }));

    if (companyName === "ntt" || companyName === "ntt-ft") {
      reportFinalData = reportData.map((photoData, index) => ({
        reportId: photoData.id,
        gameSpaceId: photoData.game_space_id,
        powerAssetId: photoData.power_asset_id,
        prefecturalArea: photoData.prefectural_area,
        exchangeOfficeName: photoData.exchange_office_name,
        assetInfo: photoData.asset_info,
        photographyTarget: photoData.photography_target,
        latitude: photoData.latitude,
        longitude: photoData.longitude,
        tag: tagLabelUnique[0],
        tagDisplay: tagLabelDisplay[0],
        comment: photoData.comment === null ? false : photoData.comment,
        user: photoData.name,
        playerId: photoData.player_id,
        fileUrl: photoPathArray[index] ? `${S3_BUCKET_BASE_URL}/${photoPathArray[index]}` : false,
        fileName: photoPathArray[index] ? photoFileNameArray[index].split(".jpg")[0] : false,
        occurred_datetime_jst: photoData.occurred_datetime_jst,
        allPhotoUrl: allPhotoUrl[index],
      }));
    }

    if (companyName === "hokuden") {
      reportFinalData = reportData.map((photoData, index) => ({
        reportId: photoData.id,
        gameSpaceId: photoData.game_space_id,
        powerAssetId: photoData.power_asset_id,
        powerPoleNumber: photoData.power_pole_number,
        representativeMunicipalityName: photoData.representative_municipality_name,
        branchCode: photoData.branch_code,
        latitude: photoData.latitude,
        longitude: photoData.longitude,
        tag: tagLabelUnique[0],
        tagDisplay: tagLabelDisplay[0],
        comment: photoData.comment === null ? false : photoData.comment,
        user: photoData.name,
        playerId: photoData.player_id,
        fileUrl: photoPathArray[index] ? `${S3_BUCKET_BASE_URL}/${photoPathArray[index]}` : false,
        fileName: photoPathArray[index] ? photoFileNameArray[index].split(".jpg")[0] : false,
        occurred_datetime_jst: photoData.occurred_datetime_jst,
        allPhotoUrl: allPhotoUrl[index],
      }));
    }

    if (companyName === "mitsubishi") {
      reportFinalData = reportData.map((photoData, index) => ({
        reportId: photoData.id,
        gameSpaceId: photoData.game_space_id,
        powerAssetId: photoData.power_asset_id,
        venueName: photoData.venue_name,
        latitude: photoData.latitude,
        longitude: photoData.longitude,
        tag: tagLabelUnique[0],
        tagDisplay: tagLabelDisplay[0],
        comment: photoData.comment === null ? false : photoData.comment,
        user: photoData.name,
        playerId: photoData.player_id,
        fileUrl: photoPathArray[index] ? `${S3_BUCKET_BASE_URL}/${photoPathArray[index]}` : false,
        fileName: photoPathArray[index] ? photoFileNameArray[index].split(".jpg")[0] : false,
        occurred_datetime_jst: photoData.occurred_datetime_jst,
        allPhotoUrl: allPhotoUrl[index],
      }));
    }

    if (reportFinalData.length > 0 && reportFinalData[0].fileUrl) {
      let sqlAssetQuery = {};
      sqlAssetQuery.query = `
        SELECT
            ppa.*,
            gs.*,
            gt.*,
            pae.occurred_datetime AS occurred_datetime,
            CONVERT_TZ(pae.occurred_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
            ps.*,
            padtep.*,
            rrpb.review_request_id,
            paiwais.power_asset_id AS insulated_switch
        FROM
            power_asset_event pae
        JOIN
            photo_of_power_asset ppa ON ppa.power_asset_id = pae.power_asset_id
            AND ppa.player_id = pae.player_id
            AND ppa.game_space_id = pae.game_space_id
        JOIN
            game_space gs ON gs.id = pae.game_space_id
        JOIN
            game_term gt ON gt.id = gs.game_term_id
        JOIN
            player_state ps ON pae.player_id = ps.player_id
        JOIN
            ${tableName} padtep ON pae.power_asset_id = padtep.power_asset_id
        JOIN
            review_request_photo_bind rrpb ON rrpb.photo_of_power_asset_id = ppa.id
        JOIN
          	power_asset pa ON pa.id = pae.power_asset_id
        LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = padtep.power_asset_id
        WHERE
            pae.type = 'PHOTOGRAPH'
            AND pae.power_asset_id = '${reportData[0]["power_asset_id"]}'
            AND pae.game_space_id = '${reportData[0]["game_space_id"]}'
        GROUP BY
            pae.power_asset_id, ps.player_id, occurred_datetime
        ORDER BY occurred_datetime DESC
        LIMIT 4;
      `;
      const [reportDataPhotoTemp] = yield all([
        call(getDataFromKpiDash, sqlAssetQuery, ENDPOINT.GET_DATA_API_REPLICA),
      ]);
      const reporExtratData = JSON.parse(reportDataPhotoTemp.body);

      if (reporExtratData.length > 0) {
        let companyTableName = `power_asset_detail_of_tepco`;
        if (companyName === "ntt") {
          companyTableName = `power_asset_detail_of_ntt_me`;
        } else if (companyName === "ntt-ft") {
          companyTableName = env == "dev" ? `power_asset_detail_of_ntt_me` : `power_asset_detail_of_ntt_ft`;
        } else if (companyName === "hokuden") {
          companyTableName = `power_asset_detail_of_hepco`;
        } else if (companyName === "mitsubishi") {
          companyTableName = `power_asset_detail_of_mission_venue`;
        }

        const sqlQuery1 = {
          query: `
            SELECT
                ppa.*,
                gs.*,
                gt.*,
                pae.occurred_datetime AS occurred_datetime,
                CONVERT_TZ(pae.occurred_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
                ps.*,
                padtep.*,
                rrpb.review_request_id,
                pa.*
            FROM
                power_asset_event pae
            JOIN
                photo_of_power_asset ppa ON ppa.power_asset_id = pae.power_asset_id
                AND ppa.player_id = pae.player_id
                AND ppa.game_space_id = pae.game_space_id
            JOIN
                game_space gs ON gs.id = pae.game_space_id
            JOIN
                game_term gt ON gt.id = gs.game_term_id
            JOIN
                player_state ps ON pae.player_id = ps.player_id
            JOIN
                ${companyTableName} padtep ON pae.power_asset_id = padtep.power_asset_id
            JOIN review_request_photo_bind rrpb ON rrpb.photo_of_power_asset_id = ppa.id
            JOIN
                power_asset pa ON pa.id = pae.power_asset_id
            WHERE
                pae.type = 'PHOTOGRAPH'
                AND ppa.file_name = '${reporExtratData[0]["file_name"]}'
            GROUP BY
                pae.power_asset_id, ps.player_id, occurred_datetime
            ORDER BY
                pae.occurred_datetime DESC
            LIMIT 1
          `
        }
        const [imageReviewDataTemp] = yield all([
          call(getDataFromKpiDash, sqlQuery1, ENDPOINT.GET_DATA_API_REPLICA),
        ]);

        const imageReviewData = JSON.parse(imageReviewDataTemp.body);

        // Query step2: based on fileName > asset_id, get the all other photo S3 object key
        const sqlQuery2 = {
          query: `
            SELECT
              *,
              DATE_FORMAT(CONVERT_TZ(rre.occurred_datetime, '+00:00', '+09:00'), '%Y-%m-%d %H:%i:%s') AS occurred_datetime_jst,
              paiwais.power_asset_id AS insulated_switch,
              pa.*
            FROM review_request_photo_bind rrpb
            JOIN photo_of_power_asset ppa ON rrpb.photo_of_power_asset_id = ppa.id
            JOIN game_space gs ON gs.id = ppa.game_space_id
            JOIN game_term gt ON gt.id = gs.game_term_id
            JOIN ${companyTableName} padtep ON ppa.power_asset_id	 = padtep.power_asset_id
            JOIN player_state ps ON ps.player_id = ppa.player_id
            JOIN review_request_event rre ON rrpb.review_request_id = rre.review_request_id
            JOIN power_asset pa ON pa.id = padtep.power_asset_id
            LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = padtep.power_asset_id
            WHERE rrpb.review_request_id = '${imageReviewData[0]["review_request_id"]}'
            AND rre.type = 'APPLIED';
          `
        }
        const [imageFilesDataTemp] = yield all([
          call(getDataFromKpiDash, sqlQuery2, ENDPOINT.GET_DATA_API_REPLICA),
        ]);
        let imageFilesData = JSON.parse(imageFilesDataTemp.body);

        // Query step3: Get all signedUrls
        let photoPathArray = [], photoFileNameArray = [];
        _.each(imageFilesData, function(photoData) {
          photoPathArray.push(photoData.object_key);
          photoFileNameArray.push(photoData.file_name);
        });

        _.each(imageFilesData, function(photoData, index) {
          photoData.signedUrl = `${S3_BUCKET_BASE_URL}/${encodeURIComponent(photoPathArray[index])}`;
        });

        if (imageFilesData.length > 0) {
          imageFilesData[0].occurred_datetime_jst = imageReviewData[0]["occurred_datetime_jst"].slice(0, 19).replace("T", " ");
          yield put(setViewerImageDataExtra(imageFilesData));
        }
      }
      yield put(setImageDataByOtherUsers(reporExtratData.length === 0 ? [] : reporExtratData));
      yield put(setImageDataByReportId(reportFinalData.length === 0 ? [] : reportFinalData));
      yield put(setPageTopLoader(false));
      return;
    }

    let sqlAssetQuery = {};
    sqlAssetQuery.query = `
      SELECT
          ppa.*,
          gs.*,
          gt.*,
          pae.occurred_datetime AS occurred_datetime,
          CONVERT_TZ(pae.occurred_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
          ps.*,
          padtep.*,
          rrpb.review_request_id,
          paiwais.power_asset_id AS insulated_switch
      FROM
          power_asset_event pae
      JOIN
          photo_of_power_asset ppa ON ppa.power_asset_id = pae.power_asset_id
          AND ppa.player_id = pae.player_id
          AND ppa.game_space_id = pae.game_space_id
      JOIN
          game_space gs ON gs.id = pae.game_space_id
      JOIN
          game_term gt ON gt.id = gs.game_term_id
      JOIN
          player_state ps ON pae.player_id = ps.player_id
      JOIN
          power_asset_detail_of_tepco padtep ON pae.power_asset_id = padtep.power_asset_id
      JOIN
          review_request_photo_bind rrpb ON rrpb.photo_of_power_asset_id = ppa.id
      JOIN
          power_asset pa ON pa.id = pae.power_asset_id
      LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = padtep.power_asset_id
      WHERE
          pae.type = 'PHOTOGRAPH'
          AND pae.power_asset_id = '${reportData[0]["power_asset_id"]}'
          AND pae.game_space_id = '${reportData[0]["game_space_id"]}'
      GROUP BY
          pae.power_asset_id, ps.player_id, occurred_datetime
      ORDER BY occurred_datetime DESC
      LIMIT 4;
    `;
    const [reportDataPhotoTemp] = yield all([
      call(getDataFromKpiDash, sqlAssetQuery, ENDPOINT.GET_DATA_API_REPLICA),
    ]);
    const reporExtratData = JSON.parse(reportDataPhotoTemp.body);
    if (reporExtratData.length > 0) {
      reporExtratData[0].occurred_datetime_jst = reporExtratData[0]["occurred_datetime_jst"].slice(0, 19).replace("T", " ");
    }
    yield put(setImageDataByOtherUsers(reporExtratData.length === 0 ? [] : reporExtratData));
    yield put(setImageDataByReportId(reportFinalData.length === 0 ? [] : reportFinalData));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleReportDataNtt(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const tableName = localStorage.getItem("access_key") === "qf70ypdjdzm89ypqvc4r7nf9"
    ? "power_asset_detail_of_ntt_me" : localStorage.getItem("access_key") === "lqdp4c7fuwgfz89og7q4x9f3"
    ? "power_asset_detail_of_hepco" : localStorage.getItem("access_key") === "z7n3q9m1x4p2v0ydk8twr5fb"
      ? env === "dev" ? "power_asset_detail_of_ntt_me" : "power_asset_detail_of_ntt_ft"
      : "power_asset_detail_of_tepco";

    yield put(setPageTopLoader(true));
    yield put(setReportFilteredTotal("--"));
    const type = yield select(periodType);
    let dateFrom = yield select(startDate);
    let dateTo = yield select(endDate);

    const assetFilter = yield select(filterNtt);
    const seasonIdSelected = yield select(selectedSeason);
    const pageNumber = action.payload.pageNumber === undefined ? 1 : action.payload.pageNumber || 1;
    const orderValue = assetFilter.order == "desc" ? "DESC" : "ASC";
    const tagResult = assetFilter.tagResult;

    const itemsPerPage = 10;
    const offset = (pageNumber - 1) * itemsPerPage;

    const utcFrom = moment.tz(dateFrom, "YYYY-MM-DD", "Asia/Tokyo")
      .startOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    // 半開区間：dateTo の翌日 00:00 JST を UTC にして「未満」で切る
    const utcToExclusive = moment.tz(dateTo, "YYYY-MM-DD", "Asia/Tokyo")
      .add(1, "day")
      .startOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");


    const padTypeQueryJoin = seasonIdSelected === "cmb68qvei00011vo0e591229z"
      ? `JOIN power_asset_detail pad ON padtep.power_asset_id = pad.power_asset_id`
      : ``;
    const padTypeQuery = seasonIdSelected === "cmb68qvei00011vo0e591229z"
      ? `AND pad.type = 'NTT'`
      : ``;

    // Date range query
    const dateRangeQuery = type === "season"
      ? `AND rr.report_datetime >= '${utcFrom}' AND rr.report_datetime <  '${utcToExclusive}'`
      : "";


    //　県域
    const prefecturalArea = assetFilter.prefecturalArea === "all" ? false : assetFilter.prefecturalArea;
    const prefecturalAreaQuery = prefecturalArea && prefecturalArea !== "all"
      ? `AND padtep.prefectural_area LIKE '%${prefecturalArea}%'` : "";

    // 収容局名
    const exchangeOfficeName = assetFilter.exchangeOfficeName === "all" ? false : assetFilter.exchangeOfficeName;
    const exchangeOfficeNameQuery = exchangeOfficeName && exchangeOfficeName !== "all"
      ? `AND padtep.exchange_office_name LIKE '%${exchangeOfficeName}%'` : "";

    // 設備番号 || 	電柱識別番号
    const assetInfo =
      assetFilter.assetInfo === "all"
        ? false
        : assetFilter.assetInfo;
    const assetInfoQuery =
      assetInfo && assetInfo !== "all"
        ? `AND padtep.asset_info LIKE '%${assetInfo}%'`
        : "";

    // 撮影対象
    const photographyTarget =
      assetFilter.photographyTarget === "all"
        ? false
        : assetFilter.photographyTarget;
    const photographyTargetQuery =
      photographyTarget && photographyTarget !== "all"
        ? `AND padtep.photography_target LIKE '%${photographyTarget}%'`
        : "";

    // 撮影種別
    let photoType = assetFilter.photoType === "all" ? false : assetFilter.photoType;
    let photoTypeQuery = ''; // taken from here
      if (photoType) {
        switch(photoType) {
          case "CONCRETE":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE', 'TELEGRAPH_CONCRETE_LUCKY_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE')`;
            break;
          case "CONCRETE_LUCKY":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_LUCKY_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE')`;
            break;
          case "CONCRETE_REGULAR":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE')`;
            break;
          case "STEEL":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_STEEL_PIPE_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE', 'TELEGRAPH_STEEL_PIPE_LUCKY_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE')`;
            break;
          case "STEEL_LUCKY":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_STEEL_PIPE_LUCKY_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE')`;
            break;
          case "STEEL_REGULAR":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_STEEL_PIPE_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE')`;
            break;
          case "TARGET_LUCKY":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_LUCKY_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE', 'TELEGRAPH_STEEL_PIPE_LUCKY_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE')`;
            break;
          case "TARGET_REGULAR":
            photoTypeQuery = `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE', 'TELEGRAPH_STEEL_PIPE_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE')`;
            break;
          default:
            photoTypeQuery = '';
        }
      }

    //　二段階判定対象
    const targetSubType = `'TELEGRAPH_CONCRETE_LUCKY_POLE',
                            'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE',
                            'TELEGRAPH_STEEL_PIPE_LUCKY_POLE',
                            'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE'`
    photoType = assetFilter.twoStepVerification === "all" ? false : assetFilter.twoStepVerification;
    photoTypeQuery = photoType && photoType == "target"
    ? `AND pa.sub_type IN (${targetSubType})`
    : photoType && photoType == "non-target"
      ? `AND pa.sub_type NOT IN (${targetSubType})`
      : photoTypeQuery;

    const seasonIdQuery = type === "season" && seasonIdSelected !== "all"
      ? `AND ppa.game_space_id = '${seasonIdSelected}'` : "";

    // Report tag
    const tagQuery = assetFilter.tag.length > 0
    ? `AND rcd.tag_label IN ('${assetFilter.tag.join("','")}')` : "";

    // Get count by tag name within a selected season
    let sqlQueryReportCountByTagName = {};
    sqlQueryReportCountByTagName.query = `
      SELECT
          COUNT(DISTINCT rr.id) as total_count,
          rcd.*,
          rtdn.*,
          rr.*
      FROM
          report rr
      JOIN
          report_content_detail rcd ON rr.id = rcd.report_id
      JOIN
          report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      ${dateRangeQuery}
      ${seasonIdQuery}
      ${prefecturalAreaQuery}
      ${exchangeOfficeNameQuery}
      ${assetInfoQuery}
      ${photographyTargetQuery}
      GROUP BY rcd.tag_label
      ORDER BY total_count DESC;
  `;

    let sqlQueryReportData = {};
    sqlQueryReportData.query = `
      SELECT
          rr.id,
          rr.game_space_id,
          rr.power_asset_id,
          ps.name,
          padtep.*,
          ps.player_id,
          rr.report_datetime AS occurred_datetime,
          pa.latitude,
          pa.longitude,
          CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
          GROUP_CONCAT(DISTINCT rcd.tag_id) AS tag_ids,
          GROUP_CONCAT(DISTINCT rcd.tag_label) AS tag_label,
          rcd.additional_comment AS comment,
          GROUP_CONCAT(DISTINCT rtdn.name) AS tag_display_names,
          GROUP_CONCAT(DISTINCT rp.object_key) AS photo_urls
      FROM report rr
      JOIN report_content_detail rcd ON rr.id = rcd.report_id
      JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
      LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      ${padTypeQueryJoin}
      JOIN power_asset pa ON pa.id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      ${padTypeQuery}
      ${dateRangeQuery}
      ${seasonIdQuery}
      ${photoTypeQuery}
      ${prefecturalAreaQuery}
      ${exchangeOfficeNameQuery}
      ${assetInfoQuery}
      ${photographyTargetQuery}
      ${tagQuery}
      GROUP BY rr.id
      ORDER BY rr.report_datetime ${orderValue}
      LIMIT ${itemsPerPage}
      OFFSET ${offset};
    `;

    let sqlQueryReportCount = {};
    sqlQueryReportCount.query = `
      SELECT
          COUNT(DISTINCT rr.id) as total_count
      FROM report rr
      JOIN report_content_detail rcd ON rr.id = rcd.report_id
      JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
      LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      ${padTypeQueryJoin}
      JOIN power_asset pa ON pa.id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      ${padTypeQuery}
      ${dateRangeQuery}
      ${seasonIdQuery}
      ${photoTypeQuery}
      ${prefecturalAreaQuery}
      ${exchangeOfficeNameQuery}
      ${assetInfoQuery}
      ${photographyTargetQuery}
      ${tagQuery}
    `;

    const [tagtListDataTemp, reportDataListTemp, reportDataTotalCountTemp] = yield all([
      call(getDataFromKpiDash, sqlQueryReportCountByTagName, ENDPOINT.GET_DATA_API_REPLICA),
      call(getDataFromKpiDash, sqlQueryReportData, ENDPOINT.GET_DATA_API_REPLICA),
      call(getDataFromKpiDash, sqlQueryReportCount, ENDPOINT.GET_DATA_API_REPLICA),
    ]);

    // Tag filter data with count
    const reportTagListData = JSON.parse(tagtListDataTemp.body);
    let reportTagListDataParsed = [], reportTagFilterEachData = {};
    _.each(reportTagListData, function(tagData) {
      reportTagFilterEachData.tag_id = tagData.tag_id;
      reportTagFilterEachData.label = tagData.tag_label;
      reportTagFilterEachData.tip = tagData.name;
      reportTagFilterEachData.count = tagData.total_count;
      reportTagFilterEachData.value = tagData.tag_label;
      reportTagListDataParsed.push(reportTagFilterEachData);
      reportTagFilterEachData = {};
    });
    let reportTagListDataTepcoSortParsed = reportTagListDataParsed;

    // table and total count data
    const top10ReportData = JSON.parse(reportDataListTemp.body);
    const countReportData = JSON.parse(reportDataTotalCountTemp.body);
    console.log("LOG sxi top10ReportData:", top10ReportData);

    let photoPathArray = [], photoFileNameArray = [], allPhotoUrl = [],
    tagLabelUnique = [], tagDisplayUnique = [], reportIdArray = [], resultTagArray = [];
    const reportIdToResultTagMap = new Map();
    _.each(top10ReportData, function(reportData) {
      const photoUrl = reportData.photo_urls !== null ? reportData.photo_urls.split(",") : [false];
      let fileName = reportData.photo_urls !== null ? photoUrl[0].split("Report/")[1] : false;
      fileName = encodeURIComponent(fileName);
      let tagUniqueArray = reportData.tag_label.split(",");
      let tagDisplayUniqueArray = reportData.tag_display_names.split(",");
      if (tagDisplayUniqueArray.indexOf("その他") !== -1) {
        const otherIndex = tagDisplayUniqueArray.indexOf("その他");
        tagDisplayUniqueArray[otherIndex] = reportData.comment;
      }
      photoPathArray.push(photoUrl[0]); // have multiple pic urls but use 1st one.
      photoFileNameArray.push(fileName);
      allPhotoUrl.push(photoUrl);
      tagLabelUnique.push([...new Set(tagUniqueArray)]);
      tagDisplayUnique.push([...new Set(tagDisplayUniqueArray)]);
      reportIdArray.push(reportData.id);
    });

    // get report result tags by report id
    if (reportIdArray.length > 0) {
      const reportIdString = reportIdArray.map(id => `'${id}'`).join(", ");
      const sqlQueryGetTag = {
        query: `
          SELECT report_id, result_tag_array, result_tag_flat FROM ${tagResultTable}
          WHERE
            report_id IN (
              ${reportIdString}
            );
        `,
        type: "select"
      };
      const [getTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryGetTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);

      if (getTagDataTemp.length > 0) {
        getTagDataTemp.forEach(row => {
          const reportId = row[0].stringValue;
          const resultTagArray = JSON.parse(row[1].stringValue);
          reportIdToResultTagMap.set(reportId, resultTagArray);
        });
      }
    }

    const reportAllData = top10ReportData.map((photoData, index) => {
      const resultTagArray = reportIdToResultTagMap.get(photoData.id) || [];
      return {
        reportId: photoData.id,
        prefecturalArea: photoData.prefectural_area,
        exchangeOfficeName: photoData.exchange_office_name,
        assetInfo: photoData.asset_info,
        photographygTarget: photoData.photography_target,
        latitude: photoData.latitude,
        longitude: photoData.longitude,
        tag: tagLabelUnique[index], //["対象無し", "位置ズレ", "撮影困難"],
        tagTip: tagDisplayUnique[index] == "その他" ? photoData.comment : tagDisplayUnique[index],
        user: photoData.name,
        fileUrl: photoPathArray[index] ? `${S3_BUCKET_BASE_URL}/${encodeURIComponent(photoPathArray[index])}` : false,
        fileName: photoPathArray[index] ? photoFileNameArray[index].split(".jpg")[0] : false,
        occurred_datetime: photoData.occurred_datetime_jst,
        allPhotoUrl: allPhotoUrl[index],
        resultTag:  resultTagArray,
      }
    });
    // console.log("LOG sxi reportAllData:", reportAllData);

    yield put(setReportFilteredTotal(countReportData[0] === undefined ? 0 : countReportData[0]["total_count"]));
    yield put(setReportDataNtt(reportAllData.length === 0 ? [] : reportAllData));
    yield put(setReportTagFilterDataNtt(reportTagListDataTepcoSortParsed));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleReportDataHokuden(action) {
  try {
    const tableName = "power_asset_detail_of_hepco";
    yield put(setPageTopLoader(true));
    yield put(setReportFilteredTotal("--"));
    const type = yield select(periodType);
    let dateFrom = yield select(startDate);
    let dateTo = yield select(endDate);

    const assetFilter = yield select(filterHokuden);
    const seasonIdSelected = yield select(selectedSeason);
    const pageNumber = action.payload.pageNumber === undefined ? 1 : action.payload.pageNumber || 1;
    const orderValue = assetFilter.order == "desc" ? "DESC" : "ASC";
    const tagResult = assetFilter.tagResult;

    const itemsPerPage = 10;
    const offset = (pageNumber - 1) * itemsPerPage;

    const utcFrom = moment.tz(dateFrom, "YYYY-MM-DD", "Asia/Tokyo")
      .startOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    // 半開区間：dateTo の翌日 00:00 JST を UTC にして「未満」で切る
    const utcToExclusive = moment.tz(dateTo, "YYYY-MM-DD", "Asia/Tokyo")
      .add(1, "day")
      .startOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

      // Date range query
    const dateRangeQuery = type === "season"
      ? `AND rr.report_datetime >= '${utcFrom}' AND rr.report_datetime <  '${utcToExclusive}'`
      : "";

    //　電柱番号
    const powerAssetNumber = assetFilter.powerAssetNumber === "all" ? false : assetFilter.powerAssetNumber;
    const powerAssetNumberQuery = powerAssetNumber && powerAssetNumber !== "all"
      ? `AND padtep.power_pole_number LIKE '%${powerAssetNumber}%'` : "";

    //　撮影者
    const username =
      assetFilter.username === "all"
        ? false
        : assetFilter.username;
    const usernameQuery =
      username && username !== "all"
        ? `AND ps.name LIKE '%${username}%'`
        : "";

    // 市町村名
    const cityName = assetFilter.municipality === "all" ? false : assetFilter.municipality;
    const cityNameQuery = cityName && cityName !== "all"
      ? `AND padtep.representative_municipality_code = '${cityName}'` : "";

    // 支店コード
    const branchName = assetFilter.branchName === "all" ? false : assetFilter.branchName;
    const branchNameQuery = branchName && branchName !== "all"
      ? `AND padtep.branch_code = '${branchName}'` : "";

    let photoType = assetFilter.photoType === "all" ? false : assetFilter.photoType;
    let photoTypeQuery = photoType && photoType == "CONCRETE"
    ? `AND pa.sub_type IN ('TELEGRAPH_CONCRETE_POLE', 'TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE', 'TELEGRAPH_CONCRETE_LUCKY_POLE')`
    : photoType && photoType == "STEEL"
      ? `AND pa.sub_type IN ('TELEGRAPH_STEEL_PIPE_POLE', 'TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE', 'TELEGRAPH_STEEL_PIPE_LUCKY_POLE')`
      : "";

    const seasonIdQuery = type === "season" && seasonIdSelected !== "all"
      ? `AND ppa.game_space_id = '${seasonIdSelected}'` : "";

    // Report tag
    const tagQuery = assetFilter.tag.length > 0
    ? `AND rcd.tag_label IN ('${assetFilter.tag.join("','")}')` : "";

    // Get count by tag name within a selected season
    let sqlQueryReportCountByTagName = {};
    sqlQueryReportCountByTagName.query = `
      SELECT
          COUNT(DISTINCT rr.id) as total_count,
          rcd.*,
          rtdn.*,
          rr.*
      FROM
          report rr
      JOIN
          report_content_detail rcd ON rr.id = rcd.report_id
      JOIN
          report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      JOIN power_asset_detail pad ON padtep.power_asset_id = pad.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      AND pad.type = 'HEPCO'
      ${dateRangeQuery}
      ${seasonIdQuery}
      ${powerAssetNumberQuery}
      ${cityNameQuery}
      ${branchNameQuery}
      ${usernameQuery}
      GROUP BY rcd.tag_label
      ORDER BY total_count DESC;
  `;

    let sqlQueryReportData = {};
    sqlQueryReportData.query = `
      SELECT
          rr.id,
          rr.game_space_id,
          rr.power_asset_id,
          ps.name,
          padtep.*,
          ps.player_id,
          rr.report_datetime AS occurred_datetime,
          pa.latitude,
          pa.longitude,
          CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
          GROUP_CONCAT(DISTINCT rcd.tag_id) AS tag_ids,
          GROUP_CONCAT(DISTINCT rcd.tag_label) AS tag_label,
          rcd.additional_comment AS comment,
          GROUP_CONCAT(DISTINCT rtdn.name) AS tag_display_names,
          GROUP_CONCAT(DISTINCT rp.object_key) AS photo_urls
      FROM report rr
      JOIN report_content_detail rcd ON rr.id = rcd.report_id
      JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
      LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      JOIN power_asset_detail pad ON padtep.power_asset_id = pad.power_asset_id
      JOIN power_asset pa ON pa.id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      AND pad.type = 'HEPCO'
      ${dateRangeQuery}
      ${seasonIdQuery}
      ${photoTypeQuery}
      ${powerAssetNumberQuery}
      ${cityNameQuery}
      ${branchNameQuery}
      ${usernameQuery}
      ${tagQuery}
      GROUP BY rr.id
      ORDER BY rr.report_datetime ${orderValue}
      LIMIT ${itemsPerPage}
      OFFSET ${offset};
    `;

    let sqlQueryReportCount = {};
    sqlQueryReportCount.query = `
      SELECT
          COUNT(DISTINCT rr.id) as total_count
      FROM report rr
      JOIN report_content_detail rcd ON rr.id = rcd.report_id
      JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
      LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      JOIN power_asset_detail pad ON padtep.power_asset_id = pad.power_asset_id
      JOIN power_asset pa ON pa.id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      AND pad.type = 'HEPCO'
      ${dateRangeQuery}
      ${seasonIdQuery}
      ${photoTypeQuery}
      ${powerAssetNumberQuery}
      ${cityNameQuery}
      ${branchNameQuery}
      ${usernameQuery}
      ${tagQuery}
    `;

    let sqlQueryGetCityNames = {};
    sqlQueryGetCityNames.query = `
      WITH FilteredReports AS (
        SELECT
          rr.id,
          padtep.representative_municipality_code AS city_code,
          padtep.representative_municipality_name AS city_name
        FROM report rr
        JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
        JOIN report_content_detail rcd ON rr.id = rcd.report_id
        JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
        LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
        JOIN player_state ps ON rr.player_id = ps.player_id
        JOIN power_asset_detail_of_hepco padtep ON rr.power_asset_id = padtep.power_asset_id
        JOIN power_asset_detail pad ON padtep.power_asset_id = pad.power_asset_id
        JOIN power_asset pa ON pa.id = padtep.power_asset_id
        JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
        WHERE rtdn.language_code = 'JA'
          AND rr.status = 'REGISTERED'
          AND pad.type = 'HEPCO'
          ${dateRangeQuery}
          AND ppa.game_space_id = '${seasonIdSelected}'
          ${usernameQuery}
        GROUP BY rr.id, city_code, city_name
      )
      SELECT
        city_code,
        city_name,
        COUNT(*) AS total_count
      FROM FilteredReports
      GROUP BY city_code, city_name
      ORDER BY total_count DESC;
    `;

    let sqlQueryGetBranchCode = {};
    sqlQueryGetBranchCode.query = `
      WITH FilteredReports AS (
        SELECT
          rr.id,
          padtep.branch_code AS branch_code
        FROM report rr
        JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
        JOIN report_content_detail rcd ON rr.id = rcd.report_id
        JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
        LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
        JOIN player_state ps ON rr.player_id = ps.player_id
        JOIN power_asset_detail_of_hepco padtep ON rr.power_asset_id = padtep.power_asset_id
        JOIN power_asset_detail pad ON padtep.power_asset_id = pad.power_asset_id
        JOIN power_asset pa ON pa.id = padtep.power_asset_id
        JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
        WHERE rtdn.language_code = 'JA'
          AND rr.status = 'REGISTERED'
          AND pad.type = 'HEPCO'
          ${dateRangeQuery}
          AND ppa.game_space_id = '${seasonIdSelected}'
          ${usernameQuery}
        GROUP BY rr.id, branch_code
      )
      SELECT
        branch_code,
        COUNT(*) AS total_count
      FROM FilteredReports
      GROUP BY branch_code
      ORDER BY total_count DESC;
    `;

    const [tagtListDataTemp, reportDataListTemp, reportDataTotalCountTemp, cityNameDataTemp, branchDataTemp] = yield all([
      call(getDataFromKpiDash, sqlQueryReportCountByTagName, ENDPOINT.GET_DATA_API_REPLICA),
      call(getDataFromKpiDash, sqlQueryReportData, ENDPOINT.GET_DATA_API_REPLICA),
      call(getDataFromKpiDash, sqlQueryReportCount, ENDPOINT.GET_DATA_API_REPLICA),
      call(getDataFromKpiDash, sqlQueryGetCityNames, ENDPOINT.GET_DATA_API_REPLICA),
      call(getDataFromKpiDash, sqlQueryGetBranchCode, ENDPOINT.GET_DATA_API_REPLICA),
    ]);

    // Tag filter data with count
    const reportTagListData = JSON.parse(tagtListDataTemp.body);
    let reportTagListDataParsed = [], reportTagFilterEachData = {};
    _.each(reportTagListData, function(tagData) {
      reportTagFilterEachData.tag_id = tagData.tag_id;
      reportTagFilterEachData.label = tagData.tag_label;
      reportTagFilterEachData.tip = tagData.name;
      reportTagFilterEachData.count = tagData.total_count;
      reportTagFilterEachData.value = tagData.tag_label;
      reportTagListDataParsed.push(reportTagFilterEachData);
      reportTagFilterEachData = {};
    });
    let reportTagListDataTepcoSortParsed = sortReportTags(reportTagListDataParsed);

    // table and total count data
    const top10ReportData = JSON.parse(reportDataListTemp.body);
    const countReportData = JSON.parse(reportDataTotalCountTemp.body);
    console.log("LOG sxi top10ReportData:", top10ReportData);

    const cityOptions = [
      { label: "全て", value: "all" },
      ...JSON.parse(cityNameDataTemp.body).map(item => ({
        label: `${item.city_name} (${item.total_count})`,
        value: item.city_code,
      }))
    ];

    const branchOptions = [
      { label: "全て", value: "all" },
      ...JSON.parse(branchDataTemp.body).map(item => ({
        label: `${item.branch_code} (${item.total_count})`,
        value: item.branch_code,
      }))
    ];

    let photoPathArray = [], photoFileNameArray = [], allPhotoUrl = [],
    tagLabelUnique = [], tagDisplayUnique = [], reportIdArray = [], resultTagArray = [];
    const reportIdToResultTagMap = new Map();
    _.each(top10ReportData, function(reportData) {
      const photoUrl = reportData.photo_urls !== null ? reportData.photo_urls.split(",") : [false];
      let fileName = reportData.photo_urls !== null ? photoUrl[0].split("Report/")[1] : false;
      fileName = encodeURIComponent(fileName);
      let tagUniqueArray = reportData.tag_label.split(",");
      let tagDisplayUniqueArray = reportData.tag_display_names.split(",");
      if (tagDisplayUniqueArray.indexOf("その他") !== -1) {
        const otherIndex = tagDisplayUniqueArray.indexOf("その他");
        tagDisplayUniqueArray[otherIndex] = reportData.comment;
      }
      photoPathArray.push(photoUrl[0]); // have multiple pic urls but use 1st one.
      photoFileNameArray.push(fileName);
      allPhotoUrl.push(photoUrl);
      tagLabelUnique.push([...new Set(tagUniqueArray)]);
      tagDisplayUnique.push([...new Set(tagDisplayUniqueArray)]);
      reportIdArray.push(reportData.id);
    });

    // get report result tags by report id
    if (reportIdArray.length > 0) {
      const reportIdString = reportIdArray.map(id => `'${id}'`).join(", ");
      const sqlQueryGetTag = {
        query: `
          SELECT report_id, result_tag_array, result_tag_flat FROM ${tagResultTable}
          WHERE
            report_id IN (
              ${reportIdString}
            );
        `,
        type: "select"
      };
      const [getTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryGetTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);

      if (getTagDataTemp.length > 0) {
        getTagDataTemp.forEach(row => {
          const reportId = row[0].stringValue;
          const resultTagArray = JSON.parse(row[1].stringValue);
          reportIdToResultTagMap.set(reportId, resultTagArray);
        });
      }
    }

    const reportAllData = top10ReportData.map((photoData, index) => {
      const resultTagArray = reportIdToResultTagMap.get(photoData.id) || [];
      return {
        reportId: photoData.id,
        powerPoleNumber: photoData.power_pole_number,
        areaName: photoData.representative_municipality_name,
        branchCode: photoData.branch_code,
        latitude: photoData.latitude,
        longitude: photoData.longitude,
        tag: tagLabelUnique[index], //["対象無し", "位置ズレ", "撮影困難"],
        tagTip: tagDisplayUnique[index] == "その他" ? photoData.comment : tagDisplayUnique[index],
        user: photoData.name,
        fileUrl: photoPathArray[index] ? `${S3_BUCKET_BASE_URL}/${encodeURIComponent(photoPathArray[index])}` : false,
        fileName: photoPathArray[index] ? photoFileNameArray[index].split(".jpg")[0] : false,
        occurred_datetime: photoData.occurred_datetime_jst,
        allPhotoUrl: allPhotoUrl[index],
        resultTag:  resultTagArray,
      }
    });

    yield put(setReportFilteredTotal(countReportData[0] === undefined ? 0 : countReportData[0]["total_count"]));
    yield put(setReportDataHokuden(reportAllData.length === 0 ? [] : reportAllData));
    yield put(setReportTagFilterDataHokuden(reportTagListDataTepcoSortParsed));
    yield put(setHokudenReportOptionCity(cityOptions));
    yield put(setHokudenReportOptionBranch(branchOptions));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleReportDataTepco(action) {
  try {
    const tableName = "power_asset_detail_of_tepco";
    yield put(setPageTopLoader(true));
    yield put(setReportFilteredTotal("--"));
    const type = yield select(periodType);
    let dateFrom = yield select(startDate);
    let dateTo = yield select(endDate);

    const utcFrom = moment.tz(dateFrom, "YYYY-MM-DD", "Asia/Tokyo")
      .startOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    // 半開区間：dateTo の翌日 00:00 JST を UTC にして「未満」で切る
    const utcToExclusive = moment.tz(dateTo, "YYYY-MM-DD", "Asia/Tokyo")
      .add(1, "day")
      .startOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    const assetFilter = yield select(filter);
    const seasonIdSelected = yield select(selectedSeason);
    const pageNumber = action.payload.pageNumber === undefined ? 1 : action.payload.pageNumber || 1;
    const orderValue = assetFilter.order == "desc" ? "DESC" : "ASC";
    const equipmentNumber = assetFilter.assetId === null ? false : assetFilter.assetId;
    const signNumber = assetFilter.signNumber === null ? false : assetFilter.signNumber;
    let assetType = assetFilter.assetType === "all" ? false : assetFilter.assetType;
    const manageGroup = assetFilter.manageGroup.key === "all" ? false : assetFilter.manageGroup.value;
    const reportTime = assetFilter.reportTime;
    const tagResult = assetFilter.tagResult;
    const includesUnconfirmed = tagResult.includes("-（未確認）");

    const itemsPerPage = 10;
    const offset = (pageNumber - 1) * itemsPerPage;
    let confirmedReportIds = [];

    // Date range query
    const dateRangeQuery = type === "season"
      ? `AND rr.report_datetime >= '${utcFrom}' AND rr.report_datetime <  '${utcToExclusive}'`
      : "";

    // 報告確認結果 if tagResult is not empty, then fetch data by tagResult from KPI RDS first
    let tagResultWhereQuery = ``;
    let confirmedReportIdsAll = [];
    if (tagResult.length > 0) {
      const seasonIdQuery = type === "season" && seasonIdSelected !== "all"
        ? `AND game_space_id = '${seasonIdSelected}'` : "";
      let managementGroupQuery = ``;
      if (manageGroup) {
        const manageGroupCommaSeparated = manageGroup.join("','");
        managementGroupQuery = `AND place_code IN ('${manageGroupCommaSeparated}')`;
      }
      const signNumberQuery = signNumber
        ? `AND sign_number = '${signNumber}'` : "";
      const assetIdQuery = equipmentNumber
        ? `AND equipment_number = '${equipmentNumber}'` : "";

      if (includesUnconfirmed) {
        const sqlQueryExcludeConfirmed = {
          query: `
            SELECT DISTINCT report_id
            FROM ${tagResultTable}
            WHERE occurred_datetime >= '${utcFrom}'
            AND occurred_datetime < '${utcToExclusive}'
            ${seasonIdQuery}
            ${managementGroupQuery}
            ${signNumberQuery}
            ${assetIdQuery}
            ORDER BY logDate ${orderValue};
          `,
          type: "select"
        };
        const [confirmedResultTagData] = yield all([
          call(getDataFromKpiDash, sqlQueryExcludeConfirmed, ENDPOINT.GET_DATA_KPIDASH_API),
        ]);

        confirmedReportIdsAll = confirmedResultTagData.map(row => `'${row[0].stringValue}'`);
        if (confirmedReportIdsAll.length > 0) {
          tagResultWhereQuery = `AND rr.id NOT IN (${confirmedReportIdsAll.join(", ")})`;
        } else {
          tagResultWhereQuery = ``;
        }
      } else {
        const tagLikeConditions = tagResult.map(tag => `result_tag_flat LIKE '%${tag}%'`).join(" OR ");
        const sqlQueryGetResultTag = {
          query: `
            SELECT report_id, result_tag_array, result_tag_flat
            FROM ${tagResultTable}
            WHERE (${tagLikeConditions})
            AND occurred_datetime >= '${utcFrom}'
            AND occurred_datetime < '${utcToExclusive}'
            ${seasonIdQuery}
            ${managementGroupQuery}
            ${signNumberQuery}
            ${assetIdQuery}
            GROUP BY report_id
            ORDER BY logDate ${orderValue};
          `,
          type: "select"
        };
        const [getResultTagDataTemp] =
          yield all([
            call(
              getDataFromKpiDash,
              sqlQueryGetResultTag,
              ENDPOINT.GET_DATA_KPIDASH_API
            ),
          ]);
        if (getResultTagDataTemp.length > 0) {
          confirmedReportIdsAll = getResultTagDataTemp.map(row => `'${row[0].stringValue}'`);
          tagResultWhereQuery = `AND rr.id IN (${confirmedReportIdsAll.join(", ")})`;
        } else {
          yield put(setReportFilteredTotal(0));
          yield put(setReportData([]));
          yield put(setPageTopLoader(false));
          return;
        }
      }
    }

    // 地上設備 x 2種類
    let assetType2 = "";
    if (assetType && assetType.includes("GROUND_EQUIPMENT")) {
      assetType2 = assetType.split("-")[1];
      assetType = assetType.split("-")[0];
    }

    const seasonIdQuery = type === "season" && seasonIdSelected !== "all"
      ? `AND ppa.game_space_id = '${seasonIdSelected}'` : "";

    const assetIdQuery = equipmentNumber
      ? `AND padtep.equipment_number = '${equipmentNumber}'` : "";

    const signNumberQuery = signNumber
      ? `AND padtep.sign_number = '${signNumber}'` : "";

    let assetTypeQuery = assetType && assetType !== "POWER_POLE_HAS_PROTECTIVE_TUBE_ALL"
      ? `AND pa.type = '${assetType}'` : "";

    const assetTypeQuery2 = assetType2 !== "" ? `AND padtep.equipment_code = '${assetType2}'` : "";

    // 防護管付き電柱
    let bogokanJoinQuery = ``;
    let bogokanWhereQuery = ``;
    if (assetType && assetType.includes("POWER_POLE_HAS_PROTECTIVE_TUBE_ALL")) {
      bogokanJoinQuery = `JOIN power_pole pp ON rr.power_asset_id = pp.id`
      bogokanWhereQuery = `AND pp.power_pole_type = 'HAS_PROTECTIVE_TUBE'`
    } else if (assetType && assetType.includes("POWER_POLE_HAS_PROTECTIVE_TUBE_WITH_PIC")) {
      bogokanJoinQuery = `
        JOIN power_asset_angle_of_view_name_v2 paaovn ON paaovn.power_asset_photography_target_id = ppa.power_asset_photography_target_id
        AND paaovn.language_code = 'JA'
        JOIN power_pole pp ON rr.power_asset_id = pp.id
      `;
      bogokanWhereQuery = `AND pp.power_pole_type = 'HAS_PROTECTIVE_TUBE' AND paaovn.angle_of_view_name like '% - 防護管%'`
      assetTypeQuery = "";
    }

    // 高圧設備あり
    let plantInsulateSwitchJoinQuery = ``;
    let plantInsulateSwitchWhereQuery = ``;
    if (assetType && assetType.includes("POWER_POLE_HAS_INSULATE_SWITCH")) {
      plantInsulateSwitchJoinQuery = `LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = pa.id`
      plantInsulateSwitchWhereQuery = `
      AND pa.type = 'POWER_POLE'
      AND paiwais.power_asset_id is not NULL`;
      assetTypeQuery = "";
    }

    // 低圧
    if (assetType && assetType.includes("POWER_POLE_NO_INSULATE_SWITCH")) {
      plantInsulateSwitchJoinQuery = `LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = pa.id`
      plantInsulateSwitchWhereQuery = `
      AND pa.type = 'POWER_POLE'
      AND paiwais.power_asset_id is NULL`;
      assetTypeQuery = "";
    };

    // ツルツタ台帳記載
    if (assetType && assetType.includes("POWER_POLE_HAS_PLNAT")) {
      plantInsulateSwitchJoinQuery = `LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = pa.id`
      plantInsulateSwitchWhereQuery = `
        AND pa.type = 'POWER_POLE'
        AND pa.sub_type = 'WITH_PLANTS'
      `;
      assetTypeQuery = "";
    }

    // ツルツタ台帳記載・高圧設備あり
    if (assetType && assetType.includes("POWER_POLE_HAS_PLNAT_AND_INSULATE_SWITCH")) {
      plantInsulateSwitchJoinQuery = `LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais ON paiwais.power_asset_id = pa.id`
      plantInsulateSwitchWhereQuery = `
        AND pa.type = 'POWER_POLE'
        AND pa.sub_type = 'WITH_PLANTS'
        AND paiwais.power_asset_id is not NULL
      `;
      assetTypeQuery = "";
    }

    // 配電保守グループ
    let managementGroupQuery = ``;
    if (manageGroup) {
      const manageGroupCommaSeparated = manageGroup.join("','");
      managementGroupQuery = `AND padtep.place_code IN ('${manageGroupCommaSeparated}')`;
    }

    const tagQuery = assetFilter.tag.length > 0
      ? `AND rcd.tag_label IN ('${assetFilter.tag.join("','")}')` : "";

    // ツルツタレビューOK画像
    let reviewRequestJoinQuery = `JOIN review_request rreq ON rreq.power_asset_id = rr.power_asset_id`;
    if (reportTime === "all") {
      reviewRequestJoinQuery = `
      JOIN review_request rere ON rere.power_asset_id = rr.power_asset_id AND rere.status = 'APPROVED' and ps.player_id = rere.player_id
      JOIN review_request_event rre ON rere.id = rre.review_request_id AND rre.type = 'APPLIED' AND rre.occurred_datetime = re.occurred_datetime
      JOIN review_request_photo_bind rrpb ON rrpb.review_request_id = rere.id
      `
    } else {
      reviewRequestJoinQuery = `
      JOIN review_request rere ON rere.power_asset_id = rr.power_asset_id AND rere.status = 'APPROVED' and ps.player_id = rere.player_id
      JOIN review_request_event rre ON rere.id = rre.review_request_id AND rre.type = 'APPLIED' AND rre.occurred_datetime = re.occurred_datetime
      JOIN review_request_event rre2 ON rere.id = rre2.review_request_id AND rre2.type = 'APPROVED'
      JOIN review_request_event_of_approved rreoa ON rre2.id = rreoa.id AND rreoa.review_approved_count = '${reportTime}'
      JOIN review_request_photo_bind rrpb ON rrpb.review_request_id = rere.id
      `
    }

    let tagtListDataTemp = [];
    let reportDataListTemp = [];
    let reportDataTotalCountTemp = [];
    let sqlQueryReportCountByTagName = {};

    if (confirmedReportIdsAll.length > 0) {
      const CHUNK_SIZE = 10;
      const idChunks = chunk(confirmedReportIdsAll, CHUNK_SIZE); // 10件ずつ分割
      reportDataListTemp = [];

      const paginatedIds = confirmedReportIdsAll.slice(offset, offset + itemsPerPage);

      const idChunkQuery = includesUnconfirmed
        ? `AND rr.id NOT IN (${confirmedReportIdsAll.join(", ")})`
        : `AND rr.id IN (${paginatedIds.join(", ")})`

      const chunkedSqlQuery = {
        query: `
          SELECT
            rr.id,
            rr.game_space_id,
            rr.power_asset_id,
            ps.name,
            padtep.*,
            ps.player_id,
            rr.report_datetime AS occurred_datetime,
            pa.latitude,
            pa.longitude,
            CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
            GROUP_CONCAT(DISTINCT rcd.tag_id) AS tag_ids,
            GROUP_CONCAT(DISTINCT rcd.tag_label) AS tag_label,
            rcd.additional_comment AS comment,
            GROUP_CONCAT(DISTINCT rtdn.name) AS tag_display_names,
            GROUP_CONCAT(DISTINCT rp.object_key) AS photo_urls
          FROM report rr
          JOIN report_content_detail rcd ON rr.id = rcd.report_id
          JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
          JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
          LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
          JOIN player_state ps ON rr.player_id = ps.player_id
          JOIN power_asset_detail_of_tepco padtep ON rr.power_asset_id = padtep.power_asset_id
          JOIN power_asset_detail pad ON padtep.power_asset_id = pad.power_asset_id
          JOIN power_asset pa ON pa.id = padtep.power_asset_id
          JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
          ${bogokanJoinQuery}
          ${plantInsulateSwitchJoinQuery}
          WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
          ${dateRangeQuery}
          ${seasonIdQuery}
          ${assetIdQuery}
          ${signNumberQuery}
          ${managementGroupQuery}
          ${tagQuery}
          ${assetTypeQuery}
          ${assetTypeQuery2}
          ${bogokanWhereQuery}
          ${plantInsulateSwitchWhereQuery}
          ${idChunkQuery}
          GROUP BY rr.id
          ORDER BY rr.report_datetime ${orderValue}
          LIMIT ${itemsPerPage}
          OFFSET ${offset}
          `,
        type: "select"
      };

      try {
        const chunkResult = yield call(getDataFromKpiDash, chunkedSqlQuery, ENDPOINT.GET_DATA_API_REPLICA);
        const parsed = JSON.parse(chunkResult.body || "[]");
        reportDataListTemp = reportDataListTemp.concat(parsed);
      } catch (error) {
        console.error("Chunked report data fetch failed:", error);
      }

      // 全件数は confirmedReportIdsAll.length に依存
      reportDataTotalCountTemp = [{ total_count: confirmedReportIdsAll.length }];

      if (includesUnconfirmed) {
        const countTotalSqlQuery = {
          query: `
            SELECT
              COUNT(DISTINCT rr.id) as total_count
            FROM report rr
            JOIN report_content_detail rcd ON rr.id = rcd.report_id
            JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
            JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
            LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
            JOIN player_state ps ON rr.player_id = ps.player_id
            JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
            JOIN power_asset pa ON pa.id = padtep.power_asset_id
            JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
            ${bogokanJoinQuery}
            ${plantInsulateSwitchJoinQuery}
            WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
            ${dateRangeQuery}
            ${seasonIdQuery}
            ${assetIdQuery}
            ${signNumberQuery}
            ${managementGroupQuery}
            ${tagQuery}
            ${assetTypeQuery}
            ${assetTypeQuery2}
            ${bogokanWhereQuery}
            ${plantInsulateSwitchWhereQuery}
            `,
          type: "select"
        };
        const [tagCountAll] = yield all([
          call(getDataFromKpiDash, countTotalSqlQuery, ENDPOINT.GET_DATA_API_REPLICA)
        ]);
        const parsedTotalCount = JSON.parse(tagCountAll.body || 0);
        reportDataTotalCountTemp = [{ total_count: parsedTotalCount[0]["total_count"] - confirmedReportIdsAll.length }];
      }

      const [tagCountResult] = yield all([
        call(getDataFromKpiDash, sqlQueryReportCountByTagName, ENDPOINT.GET_DATA_API_REPLICA)
      ]);
      tagtListDataTemp = tagCountResult;
    } else {
      sqlQueryReportCountByTagName.query = `
        SELECT
            COUNT(DISTINCT rr.id) as total_count,
            rcd.*,
            rtdn.*,
            rr.*
        FROM
            report rr
        JOIN
            report_content_detail rcd ON rr.id = rcd.report_id
        JOIN
            report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
        JOIN player_state ps ON rr.player_id = ps.player_id
        JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
        JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
        WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
        ${dateRangeQuery}
        ${seasonIdQuery}
        GROUP BY rcd.tag_label
        ORDER BY total_count DESC;
      `;

      let sqlQueryReportData = {};
      sqlQueryReportData.query = `
        SELECT
            rr.id,
            rr.game_space_id,
            rr.power_asset_id,
            ps.name,
            padtep.*,
            ps.player_id,
            padtep.place_code,
            padtep.sign_number,
            padtep.sign_name,
            padtep.equipment_code,
            padtep.equipment_number,
            pa.latitude,
            pa.longitude,
            rr.report_datetime AS occurred_datetime,
            CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
            GROUP_CONCAT(DISTINCT rcd.tag_id) AS tag_ids,
            GROUP_CONCAT(DISTINCT rcd.tag_label) AS tag_label,
            rcd.additional_comment AS comment,
            GROUP_CONCAT(DISTINCT rtdn.name) AS tag_display_names,
            GROUP_CONCAT(DISTINCT rp.object_key) AS photo_urls
        FROM report rr
        JOIN report_content_detail rcd ON rr.id = rcd.report_id
        JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
        JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
        LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
        JOIN player_state ps ON rr.player_id = ps.player_id
        JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
        JOIN power_asset pa ON pa.id = padtep.power_asset_id
        JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
        ${bogokanJoinQuery}
        ${plantInsulateSwitchJoinQuery}
        WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
        ${dateRangeQuery}
        ${seasonIdQuery}
        ${assetIdQuery}
        ${signNumberQuery}
        ${managementGroupQuery}
        ${tagQuery}
        ${assetTypeQuery}
        ${assetTypeQuery2}
        ${bogokanWhereQuery}
        ${plantInsulateSwitchWhereQuery}
        ${tagResultWhereQuery}
        GROUP BY rr.id
        ORDER BY rr.report_datetime ${orderValue}
        LIMIT ${itemsPerPage}
        OFFSET ${offset};
      `;

      let sqlQueryReportCount = {};
      sqlQueryReportCount.query = `
        SELECT
            COUNT(DISTINCT rr.id) as total_count
        FROM report rr
        JOIN report_content_detail rcd ON rr.id = rcd.report_id
        JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
        JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
        LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
        JOIN player_state ps ON rr.player_id = ps.player_id
        JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
        JOIN power_asset pa ON pa.id = padtep.power_asset_id
        JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
        ${bogokanJoinQuery}
        ${plantInsulateSwitchJoinQuery}
        WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
        ${dateRangeQuery}
        ${seasonIdQuery}
        ${assetIdQuery}
        ${signNumberQuery}
        ${managementGroupQuery}
        ${tagQuery}
        ${assetTypeQuery}
        ${assetTypeQuery2}
        ${bogokanWhereQuery}
        ${plantInsulateSwitchWhereQuery}
        ${tagResultWhereQuery}
      `;

      const [tagt, reportList, reportCount] = yield all([
        call(getDataFromKpiDash, sqlQueryReportCountByTagName, ENDPOINT.GET_DATA_API_REPLICA),
        call(getDataFromKpiDash, sqlQueryReportData, ENDPOINT.GET_DATA_API_REPLICA),
        call(getDataFromKpiDash, sqlQueryReportCount, ENDPOINT.GET_DATA_API_REPLICA),
      ]);
      tagtListDataTemp = tagt;
      reportDataListTemp = JSON.parse(reportList.body);
      reportDataTotalCountTemp = JSON.parse(reportCount.body);
    }

    // Tag filter data with count
    const reportTagListData = JSON.parse(tagtListDataTemp.body);
    let reportTagListDataParsed = [], reportTagFilterEachData = {};
    _.each(reportTagListData, function(tagData) {
      reportTagFilterEachData.tag_id = tagData.tag_id;
      reportTagFilterEachData.label = tagData.tag_label;
      reportTagFilterEachData.tip = tagData.name;
      reportTagFilterEachData.count = tagData.total_count;
      reportTagFilterEachData.value = tagData.tag_label;
      reportTagListDataParsed.push(reportTagFilterEachData);
      reportTagFilterEachData = {};
    });
    let reportTagListDataTepcoSortParsed = sortReportTags(reportTagListDataParsed);

    // table and total count data
    const top10ReportData = reportDataListTemp;
    const countReportData = reportDataTotalCountTemp;

    let photoPathArray = [], photoFileNameArray = [], allPhotoUrl = [],
    tagLabelUnique = [], tagDisplayUnique = [], reportIdArray = [], resultTagArray = [];
    const reportIdToResultTagMap = new Map();
    _.each(top10ReportData, function(reportData) {
      const photoUrl = reportData.photo_urls !== null ? reportData.photo_urls.split(",") : [false];
      const fileName = reportData.photo_urls !== null ? photoUrl[0].split("Report/")[1] : false;
      let tagUniqueArray = reportData.tag_label.split(",");
      let tagDisplayUniqueArray = reportData.tag_display_names.split(",");
      if (tagDisplayUniqueArray.indexOf("その他") !== -1) {
        const otherIndex = tagDisplayUniqueArray.indexOf("その他");
        tagDisplayUniqueArray[otherIndex] = reportData.comment;
      }
      photoPathArray.push(photoUrl[0]); // have multiple pic urls but use 1st one.
      photoFileNameArray.push(fileName);
      allPhotoUrl.push(photoUrl);
      tagLabelUnique.push([...new Set(tagUniqueArray)]);
      tagDisplayUnique.push([...new Set(tagDisplayUniqueArray)]);
      reportIdArray.push(reportData.id);
    });

    // get report result tags by report id
    if (reportIdArray.length > 0) {
      const reportIdString = reportIdArray.map(id => `'${id}'`).join(", ");
      const sqlQueryGetTag = {
        query: `
          SELECT report_id, result_tag_array, result_tag_flat FROM ${tagResultTable}
          WHERE
            report_id IN (
              ${reportIdString}
            );
        `,
        type: "select"
      };
      const [getTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryGetTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);

      if (getTagDataTemp.length > 0) {
        getTagDataTemp.forEach(row => {
          const reportId = row[0].stringValue;
          const resultTagArray = JSON.parse(row[1].stringValue);
          reportIdToResultTagMap.set(reportId, resultTagArray);
        });
      }
    }

    const reportAllData = top10ReportData.map((photoData, index) => {
      const resultTagArray = reportIdToResultTagMap.get(photoData.id) || [];
      return {
        reportId: photoData.id,
        signNumber: photoData.sign_number,
        signName: photoData.sign_name !== null && photoData.sign_name !== undefined ? photoData.sign_name : "--",
        name: photoData.equipment_number,
        placeCode: photoData.place_code !== null ? photoData.place_code : "--",
        latitude: photoData.latitude,
        longitude: photoData.longitude,
        tag: tagLabelUnique[index], //["対象無し", "位置ズレ", "撮影困難"],
        tagTip: tagDisplayUnique[index] == "その他" ? photoData.comment : tagDisplayUnique[index],
        user: photoData.name,
        fileUrl: photoPathArray[index] ? `${S3_BUCKET_BASE_URL}/${photoPathArray[index]}` : false,
        fileName: photoPathArray[index] ? photoFileNameArray[index].split(".jpg")[0] : false,
        occurred_datetime: photoData.occurred_datetime_jst,
        allPhotoUrl: allPhotoUrl[index],
        resultTag:  resultTagArray,
      }
    });
    console.log("LOG sxi reportAllData:", reportAllData);

    yield put(setReportFilteredTotal(countReportData[0] === undefined ? 0 : countReportData[0]["total_count"]));
    yield put(setReportData(reportAllData.length === 0 ? [] : reportAllData));
    yield put(setReportTagFilterData(reportTagListDataTepcoSortParsed));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleReportDataMission(action) {
  try {
    const tableName = "power_asset_detail_of_mission_venue";
    yield put(setPageTopLoader(true));
    yield put(setReportFilteredTotal("--"));
    const type = yield select(periodType);
    let dateFrom = yield select(startDate);
    let dateTo = yield select(endDate);

    const missionId = yield select(selectedMission);
    const assetFilter = yield select(filterMission); // TODO configure this when filtering became mandatory
    const pageNumber = action.payload.pageNumber === undefined ? 1 : action.payload.pageNumber || 1;
    const orderValue = assetFilter.order == "desc" ? "DESC" : "ASC";
    const tagResult = assetFilter.tagResult;

    const itemsPerPage = 10;
    const offset = (pageNumber - 1) * itemsPerPage;

    const utcFrom = moment.tz(dateFrom, "YYYY-MM-DD", "Asia/Tokyo")
      .startOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    // 半開区間：dateTo の翌日 00:00 JST を UTC にして「未満」で切る
    const utcToExclusive = moment.tz(dateTo, "YYYY-MM-DD", "Asia/Tokyo")
      .add(1, "day")
      .startOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    // Date range query
    const dateRangeQuery = `AND rr.report_datetime >= '${utcFrom}' AND rr.report_datetime <  '${utcToExclusive}'`;

    const missionIdQUery =
      missionId !== "blank" &&
      missionId !== "all"
        ? `AND rr.game_space_id = '${missionId}'`
        : "";

    // Report tag
    const tagQuery = assetFilter.tag.length > 0
    ? `AND rcd.tag_label IN ('${assetFilter.tag.join("','")}')` : "";

    // Get count by tag name within a selected season
    let sqlQueryReportCountByTagName = {};
    sqlQueryReportCountByTagName.query = `
      SELECT
          COUNT(DISTINCT rr.id) as total_count,
          rcd.*,
          rtdn.*,
          rr.*
      FROM
          report rr
      JOIN
          report_content_detail rcd ON rr.id = rcd.report_id
      JOIN
          report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      ${dateRangeQuery}
      GROUP BY rcd.tag_label
      ORDER BY total_count DESC;
  `;

    let sqlQueryReportData = {};
    sqlQueryReportData.query = `
      SELECT
          rr.id,
          rr.game_space_id,
          rr.power_asset_id,
          ps.name,
          padtep.*,
          ps.player_id,
          rr.report_datetime AS occurred_datetime,
          pa.latitude,
          pa.longitude,
          CONVERT_TZ(rr.report_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
          GROUP_CONCAT(DISTINCT rcd.tag_id) AS tag_ids,
          GROUP_CONCAT(DISTINCT rcd.tag_label) AS tag_label,
          rcd.additional_comment AS comment,
          GROUP_CONCAT(DISTINCT rtdn.name) AS tag_display_names,
          GROUP_CONCAT(DISTINCT rp.object_key) AS photo_urls
      FROM report rr
      JOIN report_content_detail rcd ON rr.id = rcd.report_id
      JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
      LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      JOIN power_asset pa ON pa.id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      ${dateRangeQuery}
      ${missionIdQUery}
      ${tagQuery}
      GROUP BY rr.id
      ORDER BY rr.report_datetime ${orderValue}
      LIMIT ${itemsPerPage}
      OFFSET ${offset};
    `;

    let sqlQueryReportCount = {};
    sqlQueryReportCount.query = `
      SELECT
          COUNT(DISTINCT rr.id) as total_count
      FROM report rr
      JOIN report_content_detail rcd ON rr.id = rcd.report_id
      JOIN report_tag_display_name rtdn ON rtdn.report_tag_id = rcd.tag_id
      JOIN report_event re ON rr.id = re.report_id AND re.type = 'REGISTERED'
      LEFT OUTER JOIN report_photograph rp ON rp.report_id = rr.id
      JOIN player_state ps ON rr.player_id = ps.player_id
      JOIN ${tableName} padtep ON rr.power_asset_id = padtep.power_asset_id
      JOIN power_asset pa ON pa.id = padtep.power_asset_id
      JOIN photo_of_power_asset ppa ON ppa.power_asset_id = rr.power_asset_id
      WHERE rtdn.language_code = 'JA' AND rr.status = 'REGISTERED'
      ${dateRangeQuery}
      ${missionIdQUery}
      ${tagQuery}
    `;

    const [tagtListDataTemp, reportDataListTemp, reportDataTotalCountTemp] = yield all([
      call(getDataFromKpiDash, sqlQueryReportCountByTagName, ENDPOINT.GET_DATA_API_REPLICA),
      call(getDataFromKpiDash, sqlQueryReportData, ENDPOINT.GET_DATA_API_REPLICA),
      call(getDataFromKpiDash, sqlQueryReportCount, ENDPOINT.GET_DATA_API_REPLICA),
    ]);

    // Tag filter data with count
    const reportTagListData = JSON.parse(tagtListDataTemp.body);
    let reportTagListDataParsed = [], reportTagFilterEachData = {};
    _.each(reportTagListData, function(tagData) {
      reportTagFilterEachData.tag_id = tagData.tag_id;
      reportTagFilterEachData.label = tagData.tag_label;
      reportTagFilterEachData.tip = tagData.name;
      reportTagFilterEachData.count = tagData.total_count;
      reportTagFilterEachData.value = tagData.tag_label;
      reportTagListDataParsed.push(reportTagFilterEachData);
      reportTagFilterEachData = {};
    });
    let reportTagListDataTepcoSortParsed = reportTagListDataParsed;

    // table and total count data
    const top10ReportData = JSON.parse(reportDataListTemp.body);
    const countReportData = JSON.parse(reportDataTotalCountTemp.body);

    let photoPathArray = [], photoFileNameArray = [], allPhotoUrl = [],
    tagLabelUnique = [], tagDisplayUnique = [], reportIdArray = [], resultTagArray = [];
    const reportIdToResultTagMap = new Map();
    _.each(top10ReportData, function(reportData) {
      const photoUrl = reportData.photo_urls !== null ? reportData.photo_urls.split(",") : [false];
      let fileName = reportData.photo_urls !== null ? photoUrl[0].split("Report/")[1] : false;
      fileName = encodeURIComponent(fileName);
      let tagUniqueArray = reportData.tag_label.split(",");
      let tagDisplayUniqueArray = reportData.tag_display_names.split(",");
      if (tagDisplayUniqueArray.indexOf("その他") !== -1) {
        const otherIndex = tagDisplayUniqueArray.indexOf("その他");
        tagDisplayUniqueArray[otherIndex] = reportData.comment;
      }
      photoPathArray.push(photoUrl[0]); // have multiple pic urls but use 1st one.
      photoFileNameArray.push(fileName);
      allPhotoUrl.push(photoUrl);
      tagLabelUnique.push([...new Set(tagUniqueArray)]);
      tagDisplayUnique.push([...new Set(tagDisplayUniqueArray)]);
      reportIdArray.push(reportData.id);
    });

    // get report result tags by report id
    if (reportIdArray.length > 0) {
      const reportIdString = reportIdArray.map(id => `'${id}'`).join(", ");
      const sqlQueryGetTag = {
        query: `
          SELECT report_id, result_tag_array, result_tag_flat FROM ${tagResultTable}
          WHERE
            report_id IN (
              ${reportIdString}
            );
        `,
        type: "select"
      };
      const [getTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryGetTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);

      if (getTagDataTemp.length > 0) {
        getTagDataTemp.forEach(row => {
          const reportId = row[0].stringValue;
          const resultTagArray = JSON.parse(row[1].stringValue);
          reportIdToResultTagMap.set(reportId, resultTagArray);
        });
      }
    }

    const reportAllData = top10ReportData.map((photoData, index) => {
      const resultTagArray = reportIdToResultTagMap.get(photoData.id) || [];
      return {
        reportId: photoData.id,
        assetInfo: photoData.asset_info,
        venueName: photoData.venue_name !== null && photoData.venue_name !== undefined ? photoData.venue_name : "--",
        latitude: photoData.latitude,
        longitude: photoData.longitude,
        tag: tagLabelUnique[index], //["対象無し", "位置ズレ", "撮影困難"],
        tagTip: tagDisplayUnique[index] == "その他" ? photoData.comment : tagDisplayUnique[index],
        user: photoData.name,
        fileUrl: photoPathArray[index] ? `${S3_BUCKET_BASE_URL}/${encodeURIComponent(photoPathArray[index])}` : false,
        fileName: photoPathArray[index] ? photoFileNameArray[index].split(".jpg")[0] : false,
        occurred_datetime: photoData.occurred_datetime_jst,
        allPhotoUrl: allPhotoUrl[index],
        resultTag:  resultTagArray,
      }
    });

    yield put(setReportFilteredTotal(countReportData[0] === undefined ? 0 : countReportData[0]["total_count"]));
    yield put(setReportDataMission(reportAllData.length === 0 ? [] : reportAllData));
    yield put(setReportTagFilterDataMission(reportTagListDataTepcoSortParsed));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.log(error);
  }
}


export default function* watchMapSettings() {
  yield takeEvery(REPORT.GET_DOWNLOAD_REPORT_DATA, handleReportDownloadData);
  yield takeEvery(REPORT.GET_DOWNLOAD_REPORT_DATA_NTT, handleReportDownloadDataNtt);
  yield takeEvery(REPORT.GET_DOWNLOAD_REPORT_DATA_HOKUDEN, handleReportDownloadDataHokuden);
  yield takeEvery(REPORT.GET_IMAGE_DATA_BY_REPORT_ID, handleReportDataByReportId);
  yield takeEvery(REPORT.GET_REPORT_DATA, handleReportDataTepco);
  yield takeEvery(REPORT.GET_REPORT_DATA_NTT, handleReportDataNtt);
  yield takeEvery(REPORT.GET_REPORT_DATA_HOKUDEN, handleReportDataHokuden);
  yield takeEvery(REPORT.GET_REPORT_DATA_MISSION, handleReportDataMission);
}
